import React, { useEffect, useRef, useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import Dashboardmenus from "./Dashboardmenus";
import user from "../../../images/user.png";
import searchnormal from "../../../images/search-normal.svg";
// import SumsubWebSdk from "@sumsub/websdk-react";
import { Filter } from "bad-words";
import Junkmailmodal from "../../common/Junkmailmodal";
import {
  Chart as ChartJS,
  LineElement,
  BarElement,
  ArcElement, // For Pie charts
  CategoryScale,
  LinearScale,
  PointElement,
  LineController,
  BarController,
  PieController, // For Pie charts
  Tooltip,
  Legend,
} from "chart.js";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Countryselect } from "../../common/Commonapi";
import { authcallApi, callApi } from "../../common/API/Api";
// import Sumsub from "../paymentgatweays/Sumsub";
import up from "../../../images/up.svg";
import Down from "../../../images/selliconred.svg";
import { useTranslation } from "react-i18next";
import { useModal } from "../../common/Collapsfunction";
import { useNotification } from "../../common/Notification";
import compreface from "./commonmodal/compreface";
import { convertLocalToUTCFormatted } from "./commonmodal/Formatedtime";
import { formatPrice } from "../../common/formatPrice";
import {
  getServerTime,
  gettimezoneprefrence,
  adjustToTimezone,
  convertToServerTime,
} from "./commonmodal/Getservertime";
import { exportToExcel } from "../../common/exportToExcel";
import { Dropdown } from "react-bootstrap";
import CommonDropdown from "../../common/CommonDropdown";
import Commonloader from "../../common/Commonloader";
import ServerDatePicker from "./commonmodal/ServerDatePicker";
import CommonSpinner from "../../common/CommonSpinner";
import CommonHistorydate from "./commonmodal/CommonHistorydate";
import Pagination from "./commonmodal/Pagination";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { formatName } from "../../common/nameFormatter";
import { getlang } from "./commonmodal/Commonapis";
import { getBaseUrl } from "../../common/BaseUrl";
import useLanguage from "../../common/useLanguage";
import Userverify from "./commonmodal/Userverify";
import { QRCodeCanvas } from "qrcode.react";
const Accountprofile = () => {
  const { langcode } = useLanguage();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
     const [qrUrl, setQrUrl] = useState("");
       const authtoken = localStorage.getItem('token');
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [modelloading, setModelloading] = useState(false);
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  // const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/jpg"];
  const [docloader, serDocloader] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [documentlist, setDocumentlist] = useState([]);
  const [documentType, setDocumentType] = useState("");
  const [loadingactive, setLoadingactive] = useState(true);
  const [loadinglogin, setLoadinglogin] = useState(true);
  const [userdocumentlist, setUserdocumentlist] = useState([]);
  // const [showCamera, setShowCamera] = useState(false);
  const [uploaddisable, setUploaddisable] = useState(false);
  const imageinputRef = useRef(null);
  // const fileInputRef = useRef(null);
  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      const reader = new FileReader();
      reader.onload = () => setImageSrc(reader.result);
      reader.readAsDataURL(file);
      e.target.value = null;
    }
  };
  const filter = new Filter();
  const location = useLocation();
  const [dobParts, setDobParts] = useState({
    day: null,
    month: null,
    year: null,
  });

  const [tempDobParts, setTempDobParts] = useState({
    day: null,
    month: null,
    year: null,
  });
  const state = location.state;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotlepages] = useState();
  const [currentPageactive, setCurrentPageactive] = useState(1);
  const [totalPagesactive, setTotlepagesactive] = useState();
  const [itemsPerPageactive, setItemperpageactive] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [itemsPerPage, setItemperpage] = useState();
  const [apiData, setApiData] = useState(null);
  const [searchhistory, setSearchHistory] = useState(null);
  const [remainingTime, setRemainingTime] = useState(0);
  const { showNotification } = useNotification();
  const [userfilter, setUserfilter] = useState();
  const [cameraAvailable, setCameraAvailable] = useState(null);
  const [error, setError] = useState("");
  const [capturedImage, setCapturedImage] = useState(null);
  const [loadingdata, setLoadingdata] = useState({
    Trade_Summary: true,
    Trades_Distribution_by_Assets: true,
    Profitability: true,
    Trade_Amounts_by_Assets: true,
  });
  const [verificationResult, setVerificationResult] = useState(null);
  const [checkopencamara, setCheckopencamara] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const [Assetlistpr, setAssetlistpre] = useState([]);
  ChartJS.register(
    LineElement,
    BarElement,
    ArcElement, // Required for Pie charts
    CategoryScale,
    LinearScale,
    PointElement,
    LineController,
    BarController,
    PieController, // Required for Pie charts
    Tooltip,
    Legend,
  );

  const [filterdates, setFilterdates] = useState({
    account_type: "real",
    start_date: "",
    end_date: "",
    asset: "",
  });

  const today = new Date();
  const currentYear = today.getFullYear();
  const [startDate, setStartDate] = useState("");
  const [updatetimezone, setUpdateTimezone] = useState();
  const [endDate, setEndDate] = useState("");
  const dropdownRef = useRef(null);
  const [walletupdate, setWallupdate] = useState(false);
  const { t, i18n } = useTranslation();
  const [langarr, setLangarr] = useState([]);
  let base_url = getBaseUrl();
  const [tradehistorylist, setTradehistorylist] = useState([]);
  const [checkcancal, setChackcancal] = useState();
  const [checkdemo, setCheckdemo] = useState("");
  const [loading, setLoading] = useState(true);
  // const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Today");
  // const [tradehistoryfilterist, setTradehistoryfilterlist] = useState([]);
  const [country, setCountry] = useState();
  const [userdata, setUserdata] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [editnickname, setEditnickname] = useState(false);
  const [socialnameloader, setSocialnameloader] = useState({
    nickname: false,
    hide_profile: false,
  });
  const [password, setPassword] = useState();
  const [profileloading, setProfileloading] = useState(false);
  const { modalRefs, openModal } = useModal();
  const navigate = useNavigate();
  const [showpassword, setShowpassword] = useState({
    password: false,
    confirmpassword: false,
    new_password: false,
  });
  const [passvalidmessage, setPassvalidmessage] = useState();
  const [loginsection, setLoginsection] = useState([]);
  const [loginhistory, setLoinhistory] = useState([]);
  const [validuser, setValiduser] = useState();
  const [profitabilityData, setProfitabilityData] = useState([]);
  const [tradeAmountsData, setTradeAmountsData] = useState();
  const [assetsDistributionData, setAssetsDistributionData] = useState([]);
  const [tradesummary, setTradesummary] = useState();
  const [showvarification, setShowvarification] = useState();
  // const [sumsubdata, setSumsubdata] = useState();
  const [deleteresion, setDeleteresion] = useState("");
  const [deletresiontext, setDeleteresiontext] = useState("");
  const [deletetext, setDeletetext] = useState("");
  const [exportexceldata, setExportexceldata] = useState([]);
  const [imageloader, setImageloader] = useState({
    loading1: false,
    loading2: false,
  });
  const [disablebuttio, setDisablebuttion] = useState({
    Security: false,
    Personal: false,
    varifylink: false,
  });
  // const [serverTime, setServerTime] = useState(null);
  const accounttypeoptcion = [
    {
      label: "Real Trading History",
      value: "real",
    },
    { label: "History of Demo Trades", value: "demo" },
  ];
  const options = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "This Week", value: "this_week" },
    { label: "Last Week", value: "last_week" },
    { label: "This Month", value: "this_month" },
    { label: "Last Month", value: "last_month" },
  ];
  const deleteresiondata = [
    "I would like to close my duplicate account",
    "The service is too confusing for me to understand",
    "I find it difficult to add funds or withdraw from my account",
    "I would like to take a break from trading and maybe resume later",
    "I need to close this account to be able to create a new one under a partner's link",
    "I am experiencing difficulties while trading that I could not manage",
    "I am lacking certain platform features or my account is somewhat limited",
    "My trading was not successful and I wish to stop",
    "Other reason (Please specify)",
  ];
  const reasonMessages = {
    "I would like to close my duplicate account": {
      text: "Thank you for closing a duplicate account as it is not allowed to have more than one trading account according with the Public Offer Agreement.",
    },

    "The service is too confusing for me to understand": {
      text: "We're sorry to hear that. Please find the extensive manual on the platform here. Whenever you're having any questions - do not hesitate to contact our {{support}}.",
    },

    "I find it difficult to add funds or withdraw from my account": {
      text: "We're sorry to hear that you experienced difficulties while performing financial operations. Please do not hesitate to contact our {{support}} to get assistance. We will be happy to find a suitable solution for you.",
    },

    "I would like to take a break from trading and maybe resume later": {
      text: "We totally understand your feelings and support you. Feel free to come back and resume your trading activity - we have a few special gifts just for you!",
    },

    "I need to close this account to be able to create a new one under a partner's link":
      {
        text: "",
      },

    "I am experiencing difficulties while trading that I could not manage": {
      text: "We're sorry to hear that you experienced any difficulties. Do not hesitate to contact our {{support}} and we will be happy to assist you.",
    },

    "I am lacking certain platform features or my account is somewhat limited":
      {
        text: "We're sorry to hear that you experienced any difficulties. Do not hesitate to contact our {{support}} and we will be happy to find a solution for you.",
      },

    "My trading was not successful and I wish to stop": {
      text: "We're sorry to hear that your trading was not as successful. Do not hesitate to contact our {{support}} and we will be happy to assist you with trading techniques and strategies and maybe even a few trading advantages.",
    },
  };
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const handleCopy = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      showNotification("Copied to clipboard!", "success");
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handledropSelect = (option) => {
    setSelectedOption(option);
    getuseralldata(userfilter?.user_id, option);
    // setIsOpen(false);
  };

  const fetchServerTime = async () => {
    const data = await getServerTime();

    if (data?.success) {
      // setServerTime(data);
      // let data12 = getDatesFromTimestamp(data?.server_time);
      // setFilterdates((state) => ({
      //   ...state,
      //   start_date: data12?.previousDate,
      //   end_date: data12?.currentDate,
      //   asset: "",
      // }));
      // let upadteddate = {
      //   account_type: "real",
      //   start_date: data12?.previousDate,
      //   end_date: data12?.currentDate,
      //   asset: "",
      // };
      // gettradehistory("filter", upadteddate);
    }
  };

  // useEffect(() => {
  //   fetchServerTime();
  // }, []);
  const fetchServerTimefordate = async () => {
    const data = await getServerTime();
    const timezonePref = await gettimezoneprefrence();

    if (data?.success) {
      const adjustedTimestamp = await adjustToTimezone(
        data.server_time,
        timezonePref.time,
      );
      return {
        ...data,
        adjustedTimestamp,
        timezonePref,
      };
    }
    return data;
  };
  useEffect(() => {
    fetchServerTimefordate();
  }, []);
  // function getDatesFromTimestamp(timestamp) {
  //   const date = new Date(timestamp);
  //   const formatDate = (d) => {
  //     const year = d.getUTCFullYear();
  //     const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  //     const day = String(d.getUTCDate()).padStart(2, "0");
  //     return `${year}-${month}-${day}`;
  //   };
  //   const currentDate = formatDate(date);
  //   const oneDayBefore = new Date(date);
  //   oneDayBefore.setUTCDate(oneDayBefore.getUTCDate() - 29);
  //   const previousDate = formatDate(oneDayBefore);
  //   return { currentDate, previousDate };
  // }
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };

  const setupuser = (key, value) => {
    setUserdata((state) => ({
      ...state,
      [key]: value,
    }));
  };
  const setuppassword = (key, value) => {
    setPassword((state) => ({
      ...state,
      [key]: value,
    }));
  };
  const uservalidaction = () => {
    let updateddata = { ...userdata };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!updateddata?.first_name) {
      setValiduser((state) => ({
        ...state,
        first_name: t("First Name is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      if (filter.isProfane(updateddata?.first_name)) {
        setValiduser((state) => ({
          ...state,
          first_name: t(
            "Please choose a different name. Bad words are not allowed.",
          ),
        }));
        return;
      } else {
        setValiduser((state) => ({
          ...state,
          first_name: "",
        }));
      }
    }
    if (!updateddata?.last_name) {
      setValiduser((state) => ({
        ...state,
        last_name: t("Last Name is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      if (filter.isProfane(updateddata?.last_name)) {
        setValiduser((state) => ({
          ...state,
          last_name: t(
            "Please choose a different name. Bad words are not allowed.",
          ),
        }));
        return;
      }
      setValiduser((state) => ({
        ...state,
        last_name: "",
      }));
    }
    if (!updateddata?.email) {
      setValiduser((state) => ({
        ...state,
        email: t("Email is Required"),
        error: "",
        success: "",
      }));
      return;
    } else if (!emailRegex.test(updateddata?.email)) {
      setValiduser((state) => ({
        ...state,
        email: t("Please enter a valid email address."),
        error: "",
        success: "",
      }));
      return;
    } else {
      setValiduser((state) => ({
        ...state,
        email: "",
      }));
    }

    if (!handleDobSave()) {
      return;
    } else {
      updateddata.dob = handleDobSave();
    }
    if (!updateddata?.dob) {
      setValiduser((state) => ({
        ...state,
        dob: t("DOB is required"),
        error: "",
        success: "",
      }));
      return;
    }
    // const today = new Date();
    const { day, month, year } = tempDobParts;
    const today = new Date();
    const monthIndex = months.indexOf(month);
    const finalDate = new Date(year, monthIndex, day);
    const birthDate = new Date(finalDate);
    const age =
      today.getFullYear() -
      birthDate.getFullYear() -
      (today <
      new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate())
        ? 1
        : 0);

    if (isNaN(birthDate.getTime())) {
      setValiduser((state) => ({
        ...state,
        dob: t("Invalid date format!"),
      }));
      return;
    } else if (age < 17 || age > 100) {
      setValiduser((state) => ({
        ...state,
        dob: t("Age must be between 18 and 100 years."),
      }));
      return;
    } else if (birthDate > today) {
      setValiduser((state) => ({
        ...state,
        dob: t("Date of birth cannot be in the future!"),
      }));
      return;
    } else {
      setValiduser((state) => ({
        ...state,
        dob: "",
      }));
    }
    if (!updateddata?.country?.label) {
      setValiduser((state) => ({
        ...state,
        country: t("Country is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setValiduser((state) => ({
        ...state,
        country: "",
      }));
    }

    if (!updateddata?.state) {
      setValiduser((state) => ({
        ...state,
        state: t("State is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setValiduser((state) => ({
        ...state,
        state: "",
      }));
    }
    if (!updateddata?.city) {
      setValiduser((state) => ({
        ...state,
        city: t("City is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setValiduser((state) => ({
        ...state,
        city: "",
      }));
    }
    if (!updateddata?.address) {
      setValiduser((state) => ({
        ...state,
        address: t("Address is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setValiduser((state) => ({
        ...state,
        address: "",
      }));
    }
    updateuser(updateddata);
  };

  const passwordvalid = () => {
    if (!password?.current_password) {
      setPassvalidmessage((state) => ({
        ...state,
        current_password: t("Current Password is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setPassvalidmessage((state) => ({
        ...state,
        current_password: "",
      }));
    }
    if (!password?.new_password) {
      setPassvalidmessage((state) => ({
        ...state,
        new_password: t("New Password is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setPassvalidmessage((state) => ({
        ...state,
        new_password: "",
      }));
    }
    if (!password?.password) {
      setPassvalidmessage((state) => ({
        ...state,
        password: t("Confirm Password is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setPassvalidmessage((state) => ({
        ...state,
        password: "",
      }));
    }

    if (password?.new_password !== password?.password) {
      setPassvalidmessage((state) => ({
        ...state,
        matchpassword: t("Passwords do not match."),
        error: "",
        success: "",
      }));
      return;
    } else {
      setPassvalidmessage((state) => ({
        ...state,
        matchpassword: "",
      }));
    }
    updatepassword(password);
  };
  // const convertDate = (isoDate) => {
  //   const date = new Date(isoDate);
  //   const formattedDate =
  //     date.toISOString().split("T")[0] +
  //     " " +
  //     date.toTimeString().split(" ")[0];
  //   return formattedDate;
  // };
  const updatepassword = async (passworddata) => {
    setDisablebuttion((state) => ({
      ...state,
      Security: true,
    }));
    let userpass = { ...passworddata };
    delete userpass?.new_password;
    try {
      const formData = new FormData();
      for (let key in userpass) {
        if (userpass.hasOwnProperty(key)) {
          formData.append(key, userpass[key]);
        }
      }
      let postdata = formData;
      let res = await authcallApi(postdata, `api/userpassword`, "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        setDisablebuttion((state) => ({
          ...state,
          Security: false,
        }));
        setPassword();
      } else {
        showNotification(res?.data?.message, "error");
        setDisablebuttion((state) => ({
          ...state,
          Security: false,
        }));
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const updateuser = async (userdata, loading) => {
    // const processToastId = showProcessToast("Loading data... Please wait.");
    setDisablebuttion((state) => ({
      ...state,
      Personal: true,
    }));
    try {
      let updatedobj = { ...userdata };
      updatedobj.country = userdata?.country?.value;
      updatedobj.name = userdata?.first_name + " " + userdata?.last_name;
      const formData = new FormData();
      for (let key in updatedobj) {
        if (updatedobj.hasOwnProperty(key)) {
          formData.append(key, updatedobj[key]);
        }
      }
      let postdata = formData;
      let res = await authcallApi(postdata, `api/useredit`, "POST");
      if (res?.data?.success) {
        // updateToastMessage(processToastId, res?.data?.message, "success");
        showNotification(res?.data?.message, "success");
        setDisablebuttion((state) => ({
          ...state,
          Personal: false,
        }));
        setShowDropdown(false);
        setTimeout(() => {
          userdetails(loading);
        }, 1000);
      } else {
        showNotification(res?.data?.message, "error");
        // updateToastMessage(processToastId, res?.data?.message, "error");
        setDisablebuttion((state) => ({
          ...state,
          Personal: false,
        }));
      }
    } catch (err) {
      console.log(err, "Err");
    } finally {
    }
  };
  const userdetails = async (loading) => {
    try {
      if (loading?.nickname) {
        setSocialnameloader((state) => ({
          ...state,
          nickname: true,
        }));
      }
      if (loading?.hide_profile) {
        setSocialnameloader((state) => ({
          ...state,
          hide_profile: true,
        }));
      }
      let res = await authcallApi({}, `api/userdetail?type=real`, "GET");
      if (res?.data?.success !== false) {
        let updateddata = { ...res?.data?.data?.user };
        if (
          updateddata?.name &&
          !updateddata.first_name &&
          !updateddata.last_name
        ) {
          const parts = updateddata.name.trim().split(/\s+/);
          if (parts.length === 2 && !isNaN(parts[1])) {
            updateddata.last_name = "";
            updateddata.first_name = "";
          } else {
            if (parts.length >= 3) {
              updateddata.last_name = parts[2];
              updateddata.first_name = parts[0] + " " + parts[1] || "";
            } else {
              updateddata.first_name = parts[0] || "";
              updateddata.last_name = parts[1] || "";
            }
          }
        }
        updateddata.country = {
          value: res?.data?.data?.user?.country,
          label: res?.data?.data?.user?.countryName,
        };
        setUserdata(updateddata);
        let userdata = res?.data?.data?.user;
        if (
          userdata?.identity_status === 1 ||
          userdata?.identity_status === 2
        ) {
          setShowvarification(true);
        } else {
          setShowvarification(false);
        }
        const mockApiResponse = {
          verification_email_resend_count:
            res?.data?.data?.user?.verification_email_resend_count,
          verification_email_resend_time:
            res?.data?.data?.user?.verification_email_resend_time,
          verification_email_current_time:
            res?.data?.data?.user?.verification_email_current_time,
        };
        setApiData(mockApiResponse);
        let userdoc = JSON.parse(updateddata?.document_types);
        getuserdocumentlist(userdoc);
      } else {
        console.error("API error:", res.error);
        setShowvarification(false);
      }
    } catch (err) {
      console.log(err, "error");
    } finally {
      setSocialnameloader((state) => ({
        ...state,
        nickname: false,
        hide_profile: false,
      }));
    }
  };

  useEffect(() => {
    userdetails({ nickname: true, hide_profile: true });
  }, []);
  const deleteprofile = async (type) => {
    try {
      setProfileloading(true);
      let postdata = { type: type };
      let res = await authcallApi(postdata, `api/deleteimage`, "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        setUserdata((state) => ({
          ...state,
          image: "",
        }));
        const modalEl = document.getElementById("removeProfileModal");
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        modal?.hide();
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setProfileloading(false);
    }
  };
  const uploadimage = async (image, type) => {
    if (type === "user_source") {
      setImageloader((state) => ({
        ...state,
        loading1: true,
      }));
    }
    let file;
    if (type === "user_target") {
      file = image;
    } else if (type === "user_source") {
      file = image.target.files[0];
    } else {
      if (image === null) {
        file = null;
      } else {
        file = image;
      }
    }
    let obj = { image: file, type: type };
    setProfileloading(true);
    // const processToastId = showProcessToast("Loading data... Please wait.");
    try {
      const formData = new FormData();
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          formData.append(key, obj[key]);
        }
      }
      let postdata = formData;
      let res = await authcallApi(postdata, `api/setimage`, "POST");
      if (res?.data?.success) {
        // updateToastMessage(processToastId, res?.data?.message, "success");
        showNotification(res?.data?.message, "success");
        if (type === "profiles") {
          setUserdata((state) => ({
            ...state,
            image: res?.data?.path,
          }));
          setImageSrc(null);
          setZoom(1);
          setCrop({ x: 0, y: 0 });
        } else if (type === "user_target") {
          setUserdata((state) => ({
            ...state,
            user_target: file,
          }));
        } else {
          setImageloader((state) => ({
            ...state,
            loading1: false,
          }));
          setUserdata((state) => ({
            ...state,
            user_source: file,
          }));
        }

        setProfileloading(false);
      } else {
        setProfileloading(false);
        showNotification(res?.data?.message, "error");
        // updateToastMessage(processToastId, res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getloginsection = async (page) => {
    try {
      setLoadingactive(true);
      let postdata = {
        page: page ? page : 1,
      };
      let res = await authcallApi(
        postdata,
        `api/getloginsessions?page=${postdata?.page}`,
      );
      if (res?.data?.success) {
        setCurrentPageactive(res?.data?.pagination?.current_page);
        setTotlepagesactive(res?.data?.pagination?.total);
        setItemperpageactive(10);
        setLoginsection(res?.data?.sessions);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingactive(false);
    }
  };
  const getloginhistory = async () => {
    try {
      setLoadinglogin(true);
      let postdata = {};
      let res = await authcallApi(postdata, `api/getloginactivity`, "GET");
      if (res?.data?.success) {
        setLoinhistory(res?.data?.last_activity);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadinglogin(false);
    }
  };
  useEffect(() => {
    getloginhistory();
    getloginsection();
  }, []);
  const getProfitability = async () => {
    try {
      setLoadingdata((state) => ({
        ...state,
        Profitability: true,
      }));
      let postdata = {};
      let start_date = startDate;
      let end_date = endDate;
      let res = await authcallApi(
        postdata,
        `api/profitchart?startDate=${start_date}&endDate=${end_date}`,
      );
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          const timezonePref = await gettimezoneprefrence();
          const updatedata = res.data.data.map((item) => {
            const adjustedTime = adjustToTimezone(item[0], timezonePref.time);
            return [adjustedTime, item[1]];
          });
          setProfitabilityData(updatedata);
        }
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdata((state) => ({
        ...state,
        Profitability: false,
      }));
    }
  };
  const gettradechart = async () => {
    try {
      setLoadingdata((state) => ({
        ...state,
        Trade_Amounts_by_Assets: true,
      }));
      let postdata = {};
      let start_date = startDate;
      let end_date = endDate;
      let res = await authcallApi(
        postdata,
        `api/tradechart?startDate=${start_date}&endDate=${end_date}`,
      );
      if (res?.data?.success) {
        const apidata = {
          categories: res?.data?.categories,
          series: res?.data?.series,
        };
        setTradeAmountsData(apidata);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdata((state) => ({
        ...state,
        Trade_Amounts_by_Assets: false,
      }));
    }
  };
  const gettradechartper = async () => {
    try {
      setLoadingdata((state) => ({
        ...state,
        Trades_Distribution_by_Assets: true,
      }));
      let postdata = {};
      let start_date = startDate;
      let end_date = endDate;
      let res = await authcallApi(
        postdata,
        `api/tradechartper?startDate=${start_date}&endDate=${end_date}`,
      );
      if (res?.data?.success) {
        const input = res?.data;
        const apidata = input.labels.map((label, index) => ({
          name: label,
          y: input.data[index],
        }));
        setAssetsDistributionData(apidata);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdata((state) => ({
        ...state,
        Trades_Distribution_by_Assets: false,
      }));
    }
  };
  const gettradesummary = async (filter, filterid) => {
    try {
      setLoadingdata((state) => ({
        ...state,
        Trade_Summary: true,
      }));
      let postdata = {};
      let start_date = startDate;
      let end_date = endDate;
      let res = await authcallApi(
        postdata,
        `api/leaderboardreport?startDate=${start_date}&endDate=${end_date}`,
        "GET",
      );
      if (res?.data?.success) {
        setTradesummary({
          ...res?.data?.trade,
          filterid: filterid ? filterid : "today-tab",
          filter: filter,
        });
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdata((state) => ({
        ...state,
        Trade_Summary: false,
      }));
    }
  };

  useEffect(() => {
    if (startDate || endDate) {
      getProfitability();
      gettradechart();
      gettradechartper();
      gettradesummary("today");
    }
  }, [startDate, endDate]);

  const gettradehistory = async (
    checkreset,
    filterdates,
    checkloading,
    checkpage,
  ) => {
    try {
      setLoading(checkloading);
      let start_date = filterdates?.start_date
        ? await filterdates?.start_date
        : "";

      let end_date = filterdates?.end_date ? await filterdates?.end_date : "";
      let account_type = filterdates?.account_type?.value || "real";
      let postdata = {
        account_type: "real",
        start_date: "",
        end_date: "",
        asset: "",
        page: checkpage ? 1 : currentPage ? currentPage : 1,
        search: searchhistory ? searchhistory : "",
      };
      let apiiurl = `api/tradehistory?account_type=${account_type}`;
      if (checkreset !== "reset" && checkreset === "filter") {
        if (start_date) apiiurl += `&start_date=${start_date}`;
        if (end_date) apiiurl += `&end_date=${end_date}`;
        apiiurl += `&limit=${20}`;
        if (filterdates?.asset?.ticker)
          apiiurl += `&asset=${filterdates?.asset?.ticker}`;
        if (postdata?.page) apiiurl += `&page=${postdata?.page}`;
        if (postdata?.search) apiiurl += `&search=${postdata?.search}`;
      }
      let res = await authcallApi(postdata, apiiurl);
      if (res?.data?.success) {
        setCurrentPage(res?.data?.current_page);
        setTotlepages(res?.data?.total_count);
        setItemperpage(res?.data?.limit);
        setCheckdemo(filterdates?.account_type?.value);
        setTradehistorylist(res?.data?.data);
        setChackcancal(res?.data?.has_valid_reward);
        // setTradehistoryfilterlist(res?.data?.data);
      }
      let apiiurlforxls = `api/tradehistory?account_type=${account_type}`;
      if (checkreset !== "reset" && checkreset === "filter") {
        if (start_date) apiiurlforxls += `&start_date=${start_date}`;
        if (end_date) apiiurlforxls += `&end_date=${end_date}`;
        apiiurlforxls += `&limit=${100000}`;
        if (postdata?.search) apiiurlforxls += `&search=${postdata?.search}`;
        if (filterdates?.asset?.ticker)
          apiiurlforxls += `&asset=${filterdates?.asset?.ticker}`;
      }
      let resxls = await authcallApi(postdata, apiiurlforxls);
      if (resxls?.data?.success) {
        if (resxls?.data?.data?.length) {
          const array =
            resxls?.data?.data?.map((item) => {
              return {
                Asset: item?.asset ?? "-",
                Info: `${item?.payout ?? ""} \n ${item?.reference_id ?? ""}`,
                Opening_time: item?.trade_timestamp
                  ? item?.trade_timestamp
                      .replace("T", " ")
                      .replace(".000000Z", "")
                  : "-",
                Opening_price: item?.entry_price ? item?.entry_price : "-",
                Closing_time: item?.close_time ? item?.close_time : "-",
                Closing_price: item?.exit_price ? item?.exit_price : "-",
                IP: item?.ip ?? "-",
                Amount: item?.amount ?? 0,
                Totel_Amount: item?.profit_loss + item?.amount ?? 0,
              };
            }) || [];

          setExportexceldata(array);
        }
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (state?.from === "trading_history") {
      fetchServerTime();
    }
  }, [state?.from]);
  // const handleSearchChange = (e) => {
  //   const query = e.target.value;
  //   if (query === "") {
  //     gettradehistory("filter", filterdates, true, true);
  //   } else {
  //     const filteredList = tradehistoryfilterist.filter((trade) =>
  //       trade.asset.toUpperCase().includes(query.toUpperCase()),
  //     );
  //     setTradehistorylist(filteredList);
  //   }
  // };
  const sendverificaionemail = async () => {
    try {
      setDisablebuttion((state) => ({
        ...state,
        varifylink: true,
      }));
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/send-email-verification-link`,
        "POST",
      );
      if (res?.data?.success) {
        openModal("junkemailmodal");
        showNotification(res?.data?.message, "success");
        setDisablebuttion((state) => ({
          ...state,
          varifylink: false,
        }));
      } else {
        setDisablebuttion((state) => ({
          ...state,
          varifylink: false,
        }));
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const cancletrade = async (id) => {
    try {
      setWallupdate(false);
      let postdata = { trade_id: id };
      let res = await authcallApi(postdata, `api/redeemgifts`, `POST`);
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        gettradehistory("filter", filterdates, false);
        setWallupdate(true);
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const handleSupportClick = () => {
    const modalElement = document.getElementById("deletepopupmodal");
    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
    modalInstance?.hide();
    navigate(`${base_url}supportdashboard`, {
      state: { from: "my_requests" },
    });
  };
  const deleteaccount = async (reason) => {
    try {
      let sendresion;
      if (reason === "Other reason (Please specify)") {
        if (!deletresiontext) {
          setDeletetext("The Please specify field is required");
          return;
        } else {
          setDeletetext("");
        }
        sendresion = deletresiontext;
      } else {
        sendresion = reason;
        setDeletetext("");
      }
      let postdata = { reason: sendresion };
      let res = await authcallApi(postdata, `api/deleteaccount`, "POST");
      if (res?.data?.success) {
        const modalElement = document.getElementById("deletepopupmodal");
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        modalInstance?.hide();
        localStorage.setItem("token", "");
        navigate(`${base_url}closeaccount`, {
          state: { from: userdata },
        });
        showNotification(res?.data?.message, "success");
        setDeletetext("");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    const modalEl = document.getElementById("deletepopupmodal");
    const handleModalHidden = () => {
      setDeleteresion("");
    };
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", handleModalHidden);
    }
    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleModalHidden);
      }
    };
  }, []);

  const terminatsessions = async (checkall, id) => {
    try {
      let array = [];
      if (checkall === "all") {
        id.forEach((item) => {
          array.push(item?.token_id);
        });
      }
      let postdata = {
        token_id: checkall === "all" ? array : [id],
      };
      let res = await authcallApi(postdata, `api/terminate-sessions`, "POST");
      if (res?.data?.success) {
        getloginsection();
        showNotification(res?.data?.message, "success");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };

  const gettimezoneprefrencegettime = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=timezoneshow`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setUpdateTimezone(parsedValue);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    gettimezoneprefrencegettime();
  }, []);

  useEffect(() => {
    const checkCamera = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoInput = devices.some(
          (device) => device.kind === "videoinput",
        );
        setCameraAvailable(hasVideoInput);
      } catch (err) {
        setCameraAvailable(false);
        setError("Error accessing media devices.");
      }
    };
    checkCamera();
  }, []);

  const startCamera = async () => {
    setError("");
    setCapturedImage(null);
    setVerificationResult(null);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
      setCheckopencamara(true);
    } catch (err) {
      setError("Unable to access the camera.");
    }
  };

  const capturePhoto = async () => {
    if (!videoRef.current || !canvasRef.current) return;
    setImageloader((state) => ({
      ...state,
      loading2: true,
    }));
    const width = videoRef.current.videoWidth;
    const height = videoRef.current.videoHeight;
    canvasRef.current.width = width;
    canvasRef.current.height = height;
    const ctx = canvasRef.current.getContext("2d");
    ctx.drawImage(videoRef.current, 0, 0, width, height);
    const imageData = canvasRef.current.toDataURL("image/jpeg");
    setCapturedImage(imageData);

    if (userdata?.user_source) {
      const blob = await base64ToBlob(imageData);
      const file = await blobToFile(blob, "image.png");
      uploadimage(file, "user_target");
      verifyFace(imageData, userdata?.user_source);
    }
  };
  // useEffect(() => {
  //   if (userdata?.user_source && userdata?.user_target) {
  //     verifyFace(userdata?.user_target, userdata?.user_source);
  //   }
  // }, [userdata]);
  function blobToFile(blob, fileName) {
    return new File([blob], fileName, { type: blob.type });
  }
  function base64ToBlob(base64Data, contentType = "image/png") {
    const byteCharacters = atob(base64Data.split(",")[1]);
    const byteArrays = [];
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }
    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type: contentType });
  }
  const verifyFace = async (capturedBase64, uploadedFile) => {
    setVerificationResult(null);
    try {
      const formData = new FormData();
      const byteString = atob(capturedBase64.split(",")[1]);
      const mimeString = capturedBase64
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });
      let uploadedimg = uploadedFile;
      // let capturedimg = capturedBase64;
      console.log(capturedBase64, uploadedFile, "capturedBase64");
      formData.append("source_image", uploadedimg);
      // formData.append("target_image", capturedimg); // captured selfie
      formData.append("target_image", blob, "captured.jpg");
      const response = await compreface.post("/verify", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.result && response.data.result.length > 0) {
        const result = response.data.result[0]?.face_matches[0];
        setVerificationResult({
          similarity: result.similarity,
          verified: result.similarity >= 0.9 ? true : false,
        });
        setImageloader((state) => ({
          ...state,
          loading2: false,
        }));
        if (result.similarity >= 0.9) {
          identifyuser();
        }
      } else {
        setVerificationResult({ error: t("No face matched.") });
      }
    } catch (err) {
      console.error("Verification error:", err);
      setVerificationResult({ error: t("Verification Pending.") });
    }
  };

  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);
  const identifyuser = async () => {
    try {
      let postdata = { identity_status: 1 };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/sumsub/status`, "POST");
      if (res?.data?.success) {
        // console.log(res?.data?.success, "res?.data?.success");
        showNotification(res?.data?.message, "success");
        userdetails();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const assetapi = async () => {
    try {
      let postdata = {};
      let res = await callApi(postdata, `api/assets`);
      if (res?.data?.success) {
        let nothing = ["Nothing Selected"];
        const mergedList = [
          ...nothing,
          ...(res?.data?.cryptocurrencieslist || []),
          ...(res?.data?.currencieslist || []),
        ];
        setAssetlistpre(mergedList);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    assetapi();
  }, []);
  function durationToSeconds(duration) {
    const [hours, minutes, seconds] = duration.split(":").map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    return "S" + totalSeconds;
  }
  const handleSelect = (value) => {
    setupuser("country", value);
  };

  const filteredCountries = country?.filter((c) =>
    c.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const handleDateChange = async (start, end) => {
    const timezonePref = await gettimezoneprefrence();
    let updatedstart = start
      ? convertToServerTime(start, timezonePref.time)
      : "";
    let updatedend = convertToServerTime(end, timezonePref.time);
    setEndDate(updatedend);
    setStartDate(updatedstart);
  };
  const handlehistryDateChange = async (start, end) => {
    const timezonePref = await gettimezoneprefrence();
    let updatedstart = convertToServerTime(start, timezonePref.time);
    let updatedend = convertToServerTime(end, timezonePref.time);
    setFilterdates((state) => ({
      ...state,
      start_date: updatedstart,
      end_date: updatedend,
    }));
    let upadteddate = {
      ...filterdates,
      start_date: updatedstart,
      end_date: updatedend,
    };
    gettradehistory("filter", upadteddate, true, true);
  };
  useEffect(() => {
    if (currentPage > 1) {
      gettradehistory("filter", filterdates, true);
    }
  }, [currentPage]);
  useEffect(() => {
    if (searchhistory) {
      gettradehistory("filter", filterdates, false, true);
    } else if (searchhistory === "") {
      gettradehistory("filter", filterdates, true);
    }
  }, [searchhistory]);
  const getuseralldata = async (id, filter) => {
    try {
      setModelloading(true);
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/leaderboarddetail?${
          filter?.value ? `filter=${filter?.value}` : ""
        }&userid=${id}&time=${updatetimezone?.time}`,
        "GET",
      );
      if (res?.data?.success) {
        setModelloading(false);
        setUserfilter(res?.data?.trade);
        setSelectedOption(filter);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  // const ReadOnlyInput = React.forwardRef(
  //   ({ value, onClick, placeholder }, ref) => (
  //     <input
  //       value={value}
  //       onClick={onClick}
  //       placeholder={placeholder}
  //       readOnly
  //       ref={ref}
  //       className="form-control"
  //     />
  //   ),
  // );

  const optionsforprofit = {
    chart: {
      type: "areaspline",
      backgroundColor: "transparent",
      height: 500,
      zooming: { type: "x" },
    },
    title: {
      text: null,
      align: "left",
      style: { fontSize: "16px", fontWeight: "bold", color: "#fff" },
    },
    xAxis: {
      type: "datetime",
      labels: {
        formatter: function () {
          // const chart = this.axis.chart;
          const index = this.axis.tickPositions.indexOf(this.value);
          const currentDate = Highcharts.dateFormat("%Y-%m-%d", this.value);
          const prevValue = this.axis.tickPositions[index - 1];
          const prevDate = prevValue
            ? Highcharts.dateFormat("%Y-%m-%d", prevValue)
            : null;
          if (!prevDate || currentDate !== prevDate) {
            return Highcharts.dateFormat("%b %e", this.value);
          } else {
            return Highcharts.dateFormat("%I:%M %p", this.value);
          }
        },
        style: { color: "#fff" },
      },
      lineWidth: 0,
      tickLength: 0,
      gridLineWidth: 0,
    },
    yAxis: {
      title: { text: null },
      gridLineWidth: 0,
      lineWidth: 0,
      labels: { style: { color: "#fff" } },
    },
    tooltip: {
      xDateFormat: "%a, %e %b, %I:%M %p",
      valueDecimals: 2,
      valuePrefix: "$",
      shared: true,
    },
    legend: { enabled: false },
    plotOptions: {
      areaspline: {
        lineWidth: 2,
        color: "#3fa9f5",
        fillOpacity: 0,
        shadow: {
          color: "rgba(63, 169, 245, 0.5)",
          width: 8,
          offsetX: 0,
          offsetY: 6,
        },
        marker: {
          radius: 0,
          symbol: "circle",
        },
      },
    },
    series: [
      {
        name: "Profit",
        data: profitabilityData,
      },
    ],

    credits: { enabled: false },
  };

  const optionsfortradedistributipon = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      // height: 500,
      // width: 400,
    },
    title: {
      text: null,
      align: "left",
      style: {
        color: "#d9d9d9",
        fontSize: "16px",
        fontWeight: "500",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      backgroundColor: "#1b1f33",
      borderColor: "#2a2f45",
      style: { color: "#fff" },
    },
    plotOptions: {
      pie: {
        innerSize: "60%",
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          distance: 15,
          style: {
            color: "#d9d9d9",
            textOutline: "none",
            fontSize: "11px",
          },
          connectorColor: "#4a4f68",
        },
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Trades",
        colorByPoint: true,
        data: assetsDistributionData,
      },
    ],
    credits: {
      enabled: false,
    },
  };
  const optionsforprofitloss = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
    },

    title: {
      text: "",
    },

    xAxis: {
      categories: tradeAmountsData?.categories,
      labels: {
        rotation: -45,
        style: {
          color: "#ffffff",
        },
      },
      lineColor: "#444",
      tickColor: "#444",
    },

    yAxis: {
      title: { text: "" },
      gridLineColor: "rgba(255,255,255,0.1)",
      labels: {
        style: { color: "#fff" },
      },
    },

    legend: {
      enabled: true,
      itemStyle: { color: "#fff" },
    },

    tooltip: {
      shared: true,
      backgroundColor: "#000",
      style: { color: "#fff" },
    },

    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },

    series: tradeAmountsData?.series,
    credits: {
      enabled: false,
    },
  };
  const clickresundbuttion = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/update-verification-resend-details`,
        "POST",
      );
      if (res?.data?.success) {
        userdetails();
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const toSeconds = (dateStr) => {
    if (!dateStr) return;
    const [datePart, timePart] = dateStr.split(" ");
    const [y, m, d] = datePart.split("-").map(Number);
    const [h, min, s] = timePart.split(":").map(Number);
    return y * 31536000 + m * 2592000 + d * 86400 + h * 3600 + min * 60 + s;
  };

  useEffect(() => {
    if (!apiData) return;
    const {
      verification_email_resend_count,
      verification_email_resend_time,
      verification_email_current_time,
    } = apiData;
    const resendSec = toSeconds(verification_email_resend_time);
    const currentSec = toSeconds(verification_email_current_time);
    const diff = currentSec - resendSec;
    const limit = verification_email_resend_count <= 10 ? 60 : 600;
    const timeLeft = Math.max(limit - diff, 0);
    setRemainingTime(timeLeft);
    const interval = setInterval(() => {
      setRemainingTime((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [apiData]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };
  useEffect(() => {
    if (!location.state) {
      navigate(location.pathname, {
        replace: true,
        state: { from: "profile" },
      });
    }
  }, [location, navigate]);
  useEffect(() => {
    if (userdata?.dob) {
      const d = new Date(userdata.dob);
      const day = String(d.getDate()).padStart(2, "0");
      const month = months[d.getMonth()];
      const year = d.getFullYear();

      setDobParts({ day, month, year });
      setTempDobParts({ day, month, year });
    }
  }, [userdata?.dob]);

  const years = [];
  for (let y = currentYear - 18; y >= currentYear - 100; y--) {
    years.push(y);
  }
  const getDaysInMonth = (monthName, year) => {
    if (!monthName || !year) return 31;
    const monthIndex = months.indexOf(monthName);
    return new Date(year, monthIndex + 1, 0).getDate();
  };
  const totalDays = getDaysInMonth(tempDobParts.month, tempDobParts.year);
  const days = Array.from({ length: totalDays }, (_, i) =>
    String(i + 1).padStart(2, "0"),
  );
  useEffect(() => {
    const total = getDaysInMonth(tempDobParts.month, tempDobParts.year);
    if (tempDobParts.day && Number(tempDobParts.day) > total) {
      setTempDobParts((prev) => ({ ...prev, day: null }));
    }
  }, [tempDobParts.month, tempDobParts.year]);
  const formattedDOB =
    dobParts.year && dobParts.month && dobParts.day
      ? `${dobParts.year}-${String(months.indexOf(dobParts.month) + 1).padStart(
          2,
          "0",
        )}-${dobParts.day}`
      : t("Select DOB");

  const goToPage = (page) => {
    const totalPagesall = Math.ceil(totalPages / itemsPerPage);
    if (page < 1 || page > totalPagesall) return;
    setCurrentPage(page);
    if (page === 1) {
      gettradehistory("filter", filterdates, true, true);
    }
  };
  const goToPageactive = (page) => {
    const totalPagesall = Math.ceil(totalPagesactive / itemsPerPageactive);
    if (page < 1 || page > totalPagesall) return;
    setCurrentPageactive(page);
    // if (page === 1) {
    getloginsection(page);
    // }
  };
  const getCroppedImg = (imageSrc, crop) => {
    const image = new Image();
    image.src = imageSrc;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = crop.width;
    canvas.height = crop.height;
    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
      0,
      0,
      crop.width,
      crop.height,
    );

    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          const file = new File([blob], "profile.webp", {
            type: "image/webp",
          });

          resolve(file);
        },
        "image/webp",
        0.9,
      );
    });
  };
  const handleSave = async (imageSrc) => {
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    uploadimage(croppedImage, "profiles");
  };
  useEffect(() => {
    const fetchLang = async () => {
      let getlangdata = await getlang();
      if (getlangdata?.length) {
        setLangarr(getlangdata);
      }
    };
    fetchLang();
  }, []);
  useEffect(() => {
    if (langcode?.Code) {
      i18n.changeLanguage(langcode.Code);
    }
  }, [langcode, i18n]);
  const setlang = (newLang) => {
    let lang = newLang?.Code;
    const currentPath = window.location.pathname.split("/").slice(2).join("/");
    navigate(`/${lang}/${currentPath}`);
  };

  const handleDobSave = () => {
    const { day, month, year } = tempDobParts;
    const today = new Date();
    const monthIndex = months.indexOf(month);
    const finalDate = new Date(year, monthIndex, day);
    const birthDate = new Date(finalDate);
    const age =
      today.getFullYear() -
      birthDate.getFullYear() -
      (today <
      new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate())
        ? 1
        : 0);
    if (!tempDobParts?.day || !tempDobParts?.month || !tempDobParts?.year) {
      setValiduser((state) => ({
        ...state,
        dob: t("DOB is required"),
        error: "",
        success: "",
      }));
      return false;
    }
    if (isNaN(birthDate.getTime())) {
      setValiduser((state) => ({
        ...state,
        dob: t("Invalid date format!"),
      }));
      return false;
    } else if (age < 17 || age > 100) {
      setValiduser((state) => ({
        ...state,
        dob: t("Age must be between 18 and 100 years."),
      }));
      return false;
    } else if (birthDate > today) {
      setValiduser((state) => ({
        ...state,
        dob: t("Date of birth cannot be in the future!"),
      }));
      return false;
    } else {
      setValiduser((state) => ({
        ...state,
        dob: "",
      }));

      if (day && month && year) {
        setupuser("dob", finalDate);
        setUserdata((state) => ({
          ...state,
          dob: finalDate,
        }));
        setDobParts(tempDobParts);
        setShowDropdown(false);

        return finalDate;
      }
    }
  };

  // useEffect(() => {
  //   const checkCamera = async () => {
  //     try {
  //       const devices = await navigator.mediaDevices.enumerateDevices();
  //       const hasVideoInput = devices.some(
  //         (device) => device.kind === "videoinput",
  //       );
  //       setCameraAvailable(hasVideoInput);
  //     } catch (err) {
  //       setCameraAvailable(false);
  //       // setError("Error accessing media devices.");
  //     }
  //   };

  //   checkCamera();
  // }, []);
  const validateFile = (file) => {
    if (!ALLOWED_TYPES.includes(file.type)) {
      return "Only JPG and PNG images are allowed";
    }
    if (file.size > MAX_FILE_SIZE) {
      return "Image size must be less than 5MB";
    }
    return "";
  };

  /* ---------------- File Select ---------------- */
  const convertToWebP = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        img.src = e.target.result;
      };
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject("Conversion failed");
            const webpFile = new File([blob], "image.webp", {
              type: "image/webp",
            });
            resolve(webpFile);
          },
          "image/webp",
          0.9,
        );
      };
      img.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const validationError = validateFile(file);
    if (validationError) {
      setError(validationError);
      return;
    }
    try {
      setError("");
      const webpFile = await convertToWebP(file);
      setSelectedFile(webpFile);
      const previewUrl = URL.createObjectURL(webpFile);
      setPreview(previewUrl);
    } catch (err) {
      setError("Image conversion failed");
    }
  };

  /* ---------------- Paste Image ---------------- */
  useEffect(() => {
    if (!isModalOpen) return;

    const handlePaste = (e) => {
      const item = [...e.clipboardData.items].find((i) =>
        i.type.startsWith("image"),
      );
      if (!item) return;
      const file = item.getAsFile();
      const validationError = validateFile(file);
      if (validationError) {
        setError(validationError);
        return;
      }
      setError("");
      setSelectedFile(file);
      setPreview(URL.createObjectURL(file));
    };
    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, [isModalOpen]);

  const getdocumenttype = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/verification-document-types`,
        "GET",
      );
      if (res?.data?.success) {
        // setDocumentlist(res?.data?.document_types);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  /* ---------------- Submit ---------------- */
  const handleSubmit = async () => {
    if (!documentType) {
      setError(t("Please select document type"));
      return;
    }
    if (!selectedFile) {
      setError(t("Please upload an image"));
      return;
    }

    setError("");
    try {
      setUploaddisable(true);
      let postdata = {
        document_type: documentType,
        document_file: selectedFile,
      };
      let res = await authcallApi(
        postdata,
        `api/verification-document-upload`,
        "POST",
      );
      if (res?.data?.success) {
        setDocumentType("");
        setSelectedFile(null);
        showNotification(res?.data?.message, "success");
        const modalEl = document.getElementById("add_documentModal");
        const modalInstance = window.bootstrap.Modal.getInstance(modalEl);

        // getuserdocumentlist();
        userdetails();
        if (modalInstance) {
          setIsModalOpen(false);
          setPreview(null);
          if (imageinputRef.current) {
            imageinputRef.current.value = "";
          }

          modalInstance.hide();
        }
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "Err");
    } finally {
      setUploaddisable(false);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      const modal = modalRefs.current["add_documentModal"];
      if (!modal) return;
      if (modal.contains(event.target)) return;
      // if (!modal.classList.contains("show")) return;
      const instance =
        window.bootstrap.Modal.getInstance(modal) ||
        new window.bootstrap.Modal(modal);

      instance.hide();
      setDocumentType("");
      setSelectedFile(null);
      setPreview(null);
      if (imageinputRef.current) {
        imageinputRef.current.value = "";
      }
      setError("");
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const getuserdocumentlist = async (userdoc) => {
    try {
      serDocloader(true);
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/user-verification-documents`,
        "GET",
      );
      if (res?.data?.success) {
        setUserdocumentlist(res?.data?.documents);
        serDocloader(false);
        const documents = res?.data?.documents || [];
        const uploadedDocs = new Set(
          (res?.data?.documents || [])
            .filter((doc) => ["approved", "pending"].includes(doc.status))
            .map((doc) => doc.document_type),
        );
        const filteredUserDocs = userdoc.filter(
          (doc) => !uploadedDocs.has(doc),
        );
        console.log(filteredUserDocs, "filteredUserDocs", userdoc);
        if (filteredUserDocs?.length) {
          setDocumentlist(filteredUserDocs);
        } else {
          setDocumentlist([]);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getdocumenttype();
    // getuserdocumentlist();
  }, []);
  /* ---------------- Open Camera ---------------- */
  // const openCamera = async () => {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({
  //       video: { facingMode: "user" },
  //     });
  //     streamRef.current = stream;
  //     videoRef.current.srcObject = stream;
  //     setShowCamera(true);
  //   } catch {
  //     setError("Camera permission denied");
  //   }
  // };

  /* ---------------- Native Camera (Mobile) ---------------- */
  // const openDeviceCamera = () => {
  //   setError("");
  //   if (isMobile) {
  //     fileInputRef.current.click();
  //   } else {
  //     openCamera();
  //   }
  // };

  /* ---------------- Capture Photo ---------------- */
  // const capturePhoto01 = () => {
  //   const video = videoRef.current;
  //   const canvas = canvasRef.current;

  //   canvas.width = video.videoWidth;
  //   canvas.height = video.videoHeight;

  //   const ctx = canvas.getContext("2d");
  //   ctx.drawImage(video, 0, 0);

  //   canvas.toBlob((blob) => {
  //     const file = new File([blob], "camera-image.jpg", {
  //       type: "image/jpeg",
  //     });

  //     const validationError = validateFile(file);
  //     if (validationError) {
  //       setError(validationError);
  //       return;
  //     }

  //     setSelectedFile(file);
  //     setPreview(URL.createObjectURL(file));
  //     closeCamera();
  //   }, "image/jpeg");
  // };

  /* ---------------- Close Camera ---------------- */
  // const closeCamera = () => {
  //   if (streamRef.current) {
  //     streamRef.current.getTracks().forEach((track) => track.stop());
  //   }
  //   setShowCamera(false);
  // };

  const resetfilter = () => {
    let filter = {
      account_type: "real",
      start_date: "",
      end_date: "",
      asset: "",
    };
    setFilterdates(filter);
    gettradehistory("reset", filter, true, true);
  };
  const compressToken = async (jwt) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(jwt);

  const stream = new CompressionStream("deflate");
  const writer = stream.writable.getWriter();

  writer.write(data);
  writer.close();

  const compressed = await new Response(stream.readable).arrayBuffer();

  const bytes = new Uint8Array(compressed);

  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};
     const generateQR = async() => {
      // const shortToken = await compressToken(authtoken);
      // console.log(shortToken, "shortToken");
      const url = `${window.location.origin}/userverify?token=${authtoken}`;
  
      setQrUrl(url);
    };
    useEffect(() => {
      generateQR()
    }, []);
  return (
    <React.Fragment>
      <Dashboardmenus walletupdate={walletupdate} />
      <div className="dashboard-contentbody">
        <section className="DepositSec">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  {/* <!-- <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="tradingprofile-tab" data-bs-toggle="tab" data-bs-target="#tradingprofile" type="button" role="tab" aria-controls="ProfileDt" aria-selected="true">Trading Profile</button>
               </li> --> */}
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "profile" && "active"
                      }`}
                      to={`${base_url}accounthistory`}
                      state={{ from: "profile" }}
                      id="profileDt-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#profileDt"
                      // type="button"
                      // role="tab"
                      // aria-controls="ProfileDt"
                      // aria-selected="true"
                    >
                      {t("Profile")}
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "analytics" && "active"
                      }`}
                      id="analytics-tab"
                      to={`${base_url}accounthistory`}
                      state={{ from: "analytics" }}
                      // data-bs-toggle="tab"
                      // data-bs-target="#analytics"
                      // type="button"
                      // role="tab"
                      // aria-controls="analytics"
                      // aria-selected="false"
                    >
                      {t("Analytics")}
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "trading_history" ? "active" : ""
                      }`}
                      to={`${base_url}accounthistory`}
                      state={{ from: "trading_history" }}
                      id="tradingHistory-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#tradingHistory"
                      // type="button"
                      // role="tab"
                      // aria-controls="tradingHistory"
                      // aria-selected="false"
                    >
                      {t("Trade History")}
                    </Link>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div
                    className={`tab-pane fade ${
                      state?.from === "profile" && "show active"
                    }`}
                    id="profileDt"
                    role="tabpanel"
                    aria-labelledby="profileDt-tab"
                  >
                    <div className="withdrawal_form">
                      <div className="cardBox mb-4">
                        <h4 className="card_title">{t("Personal Data")}</h4>
                        {!userdata ? (
                          <div className="col-lg-12 col-md-6">
                            <div className="cardBox paymentexecutionbox">
                              <div className="text-center">
                                <div
                                  className="spinner-border"
                                  role="status"
                                ></div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div action="#" className="personal_data_form">
                            <div className="row">
                              <div className="col-lg-12 col-md-12">
                                <div className="single-area profile-img">
                                  <div className="file-upload">
                                    {userdata?.profile_disable === 0 && (
                                      <div className="img-area text-center">
                                        {profileloading ? (
                                          <div
                                            className="spinner-border text-primary"
                                            role="status"
                                          >
                                            <span className="visually-hidden">
                                              {t("Loading...")}
                                            </span>
                                          </div>
                                        ) : (
                                          <img
                                            src={
                                              userdata?.image
                                                ? process.env
                                                    .REACT_APP_IMAGE_URL +
                                                  userdata?.image
                                                : user
                                            }
                                            alt="icon"
                                          />
                                        )}
                                        {/* {userdata?.image ? (
                                          <span
                                            className="remove_profile_img"
                                            data-bs-toggle="modal"
                                            data-bs-target="#removeProfileModal"
                                          >
                                            <i class="fa-solid fa-xmark"></i>
                                          </span>
                                        ) : (
                                          ""
                                        )} */}
                                        {userdata?.image ? (
                                          <div
                                            className="delete-avtar-btn mt-3"
                                            // data-bs-toggle="modal"
                                            // data-bs-target="#removeProfileModal"
                                            onClick={() =>
                                              openModal("removeProfileModal")
                                            }
                                          >
                                            <button className="btn dlt-btn pb-1">
                                              {t("Delete Avatar")}
                                            </button>
                                          </div>
                                        ) : (
                                          ""
                                        )}

                                        <div
                                          ref={(el) =>
                                            (modalRefs.current[
                                              "removeProfileModal"
                                            ] = el)
                                          }
                                          className="modal fade"
                                          id="removeProfileModal"
                                          tabindex="-1"
                                          aria-labelledby="removeProfileLabel"
                                          aria-hidden="true"
                                        >
                                          <div className="modal-dialog modal-dialog-centered">
                                            <div className="modal-content">
                                              <div className="modal-header">
                                                <h1
                                                  className="modal-title fs-5"
                                                  id="removeProfileLabel"
                                                >
                                                  {t("Confirm")}
                                                </h1>
                                                <button
                                                  type="button"
                                                  className="btn-close"
                                                  data-bs-dismiss="modal"
                                                  aria-label="Close"
                                                ></button>
                                              </div>
                                              <div className="modal-body">
                                                <p className="text-white m-0">
                                                  {t(
                                                    "Are you sure you want to remove profile image?",
                                                  )}
                                                </p>
                                              </div>
                                              <div className="modal-footer justify-content-between">
                                                <button
                                                  type="button"
                                                  className="btn bg-white fs-6 px-3 py-0 my-0"
                                                  data-bs-dismiss="modal"
                                                  style={{ minWidth: "auto" }}
                                                >
                                                  {t("No")}
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn dlt-btn fs-6 px-3"
                                                  onClick={() =>
                                                    deleteprofile("profiles")
                                                  }
                                                >
                                                  {t("Yes")}
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {userdata?.profile_disable === 0 && (
                                      <div className="right-area">
                                        <p className="title">
                                          {t("Upload profile photo via:")}
                                        </p>
                                        <label className="file">
                                          <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => onFileChange(e)}
                                          />
                                          <span className="file-custom">
                                            {t("Upload Profile Photo")}
                                          </span>
                                        </label>

                                        <p className="mdr">
                                          {t(
                                            "Choose a photo for your account.",
                                          )}
                                        </p>
                                      </div>
                                    )}
                                    {imageSrc ? (
                                      <>
                                        <div className="zoom-slider-box">
                                          <div
                                            style={{
                                              position: "relative",
                                              width: 200,
                                              height: 200,
                                              borderRadius: "100px",
                                            }}
                                          >
                                            <Cropper
                                              image={imageSrc}
                                              crop={crop}
                                              zoom={zoom}
                                              aspect={1}
                                              onCropChange={setCrop}
                                              onZoomChange={setZoom}
                                              onCropComplete={onCropComplete}
                                              zoomSpeed={0.9}
                                              objectFit="cover"
                                            />
                                          </div>
                                          <div className="zoom-slider-wrapper">
                                            <input
                                              type="range"
                                              min="1"
                                              max="3"
                                              step="0.1"
                                              value={zoom}
                                              onChange={(e) =>
                                                setZoom(e.target.value)
                                              }
                                              className="zoom-slider"
                                            />
                                          </div>
                                          <div className="zoom-slider-btns">
                                            <div
                                              onClick={() =>
                                                handleSave(imageSrc)
                                              }
                                              className="badge bg-success"
                                            >
                                              {t("Save")}
                                            </div>
                                            <div
                                              onClick={() => {
                                                setImageSrc(null);
                                                setZoom(1);
                                                setCrop({ x: 0, y: 0 });
                                              }}
                                              className="badge bg-danger"
                                            >
                                              {t("Cancel")}
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* <div className="col-lg-6 col-md-6">
                                     <div className="mb-3">
                                         <label>Nickname</label>
                                         <input type="text" name="nickname" className="form-control" placeholder="#48687230"/>
                                     </div>
                                 </div> */}
                              <div className="col-lg-6 col-md-6">
                                <div className="mb-3">
                                  <label>
                                    {t("First Name")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="first_name"
                                    className={
                                      validuser?.first_name
                                        ? "form-control border-danger"
                                        : "form-control"
                                    }
                                    placeholder={t("Enter your First Name")}
                                    value={userdata?.first_name}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (/^[\p{L}\p{M}\s]*$/u.test(value)) {
                                        setupuser("first_name", value);
                                      }
                                    }}
                                  />
                                  {validuser?.first_name ? (
                                    <p className="p-0 text-danger">
                                      {validuser?.first_name}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="mb-3">
                                  <label>
                                    {t("Last Name")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="last_name"
                                    className={
                                      validuser?.last_name
                                        ? "form-control border-danger"
                                        : "form-control"
                                    }
                                    placeholder={t("Enter your Last Name")}
                                    value={userdata?.last_name}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (/^[\p{L}\p{M}\s]*$/u.test(value)) {
                                        setupuser("last_name", value);
                                      }
                                    }}
                                  />
                                  {validuser?.last_name ? (
                                    <p className="p-0 text-danger">
                                      {validuser?.last_name}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="mb-3">
                                  <label className="email-badge">
                                    {t("Email")}{" "}
                                    {userdata?.is_email_verified ? (
                                      <span className="badge bg-success">
                                        {t("Verified")}
                                      </span>
                                    ) : (
                                      <>
                                        {/* <span className="text-danger">
                                        (Not Verified)
                                      </span>
                                   
                                      <button
                                     
                                        disabled={disablebuttio?.varifylink}
                                        
                                        className="btn bg-white"
                                        
                                      >
                                        Resend
                                      </button> */}
                                        <span class="badge bg-danger">
                                          {t("Unverified")}
                                        </span>
                                        {remainingTime > 0 ? (
                                          formatTime(remainingTime)
                                        ) : userdata ? (
                                          <button
                                            type="button"
                                            disabled={disablebuttio?.varifylink}
                                            onClick={() => {
                                              sendverificaionemail();
                                              clickresundbuttion();
                                            }}
                                            style={{ border: "none" }}
                                            class="badge bg-warning text-dark"
                                          >
                                            {t("Resend")}
                                          </button>
                                        ) : (
                                          ""
                                        )}
                                        {/* <button
                                          type="button"
                                          disabled={disablebuttio?.varifylink}
                                          onClick={() => {
                                            sendverificaionemail();
                                          }}
                                          style={{ border: "none" }}
                                          class="badge bg-warning text-dark"
                                        >
                                          Resend
                                        </button> */}
                                      </>
                                    )}
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </label>
                                  <input
                                    type="email"
                                    name="email"
                                    placeholder={t("Enter your Email")}
                                    className={
                                      validuser?.email
                                        ? "form-control border-danger"
                                        : "form-control"
                                    }
                                    value={userdata?.email}
                                    onChange={(e) =>
                                      setupuser("email", e.target.value)
                                    }
                                    disabled
                                  />
                                  {validuser?.email ? (
                                    <p className="p-0 text-danger">
                                      {validuser?.email}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="mb-3">
                                  <label className="">
                                    {t("Date of Birth")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  {!showDropdown && (
                                    <div
                                      className="text-white dateSelect01"
                                      onClick={() => setShowDropdown(true)}
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span
                                        style={{
                                          borderBottom: "1px dashed #6dafe1",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {" "}
                                        {formattedDOB}
                                      </span>
                                    </div>
                                  )}
                                  <div className="row datedropdown">
                                    {showDropdown && (
                                      <div
                                        className="col datedropdownCol"
                                        style={{ display: "flex", gap: "10px" }}
                                      >
                                        {/* DAY */}
                                        <Dropdown>
                                          <Dropdown.Toggle className="form-select form-control">
                                            {tempDobParts.day || t("DD")}
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu
                                            style={{
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            {days.map((d) => (
                                              <Dropdown.Item
                                                key={d}
                                                onClick={() =>
                                                  setTempDobParts((prev) => ({
                                                    ...prev,
                                                    day: d,
                                                  }))
                                                }
                                              >
                                                {d}
                                              </Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        </Dropdown>

                                        {/* MONTH */}
                                        <Dropdown>
                                          <Dropdown.Toggle className="form-select form-control">
                                            {t(tempDobParts.month) || t("MM")}
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu
                                            style={{
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            {months.map((m) => (
                                              <Dropdown.Item
                                                key={m}
                                                className={
                                                  tempDobParts.month === m
                                                    ? "active"
                                                    : ""
                                                }
                                                onClick={() =>
                                                  setTempDobParts((prev) => ({
                                                    ...prev,
                                                    month: m,
                                                  }))
                                                }
                                              >
                                                {t(m)}
                                              </Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        </Dropdown>

                                        {/* YEAR */}
                                        <Dropdown>
                                          <Dropdown.Toggle className="form-select form-control p-0">
                                            {/* {tempDobParts.year} */}
                                            <input
                                              type="text"
                                              className="border-0 w-100 px-2 py-1 text-white text-center"
                                              placeholder={t("YYYY")}
                                              value={tempDobParts.year || ""}
                                              onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d{0,4}$/.test(value)) {
                                                  setTempDobParts((prev) => ({
                                                    ...prev,
                                                    year: value,
                                                  }));
                                                }
                                              }}
                                              style={{
                                                outline: "none",
                                                background: "transparent",
                                              }}
                                            />
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu
                                            style={{
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            {years.map((y) => (
                                              <Dropdown.Item
                                                key={y}
                                                className={
                                                  tempDobParts.year === y
                                                    ? "active"
                                                    : ""
                                                }
                                                onClick={() =>
                                                  setTempDobParts((prev) => ({
                                                    ...prev,
                                                    year: y,
                                                  }))
                                                }
                                              >
                                                {y}
                                              </Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        </Dropdown>

                                        {/* ICONS */}
                                        <div className="icon_col d-flex align-items-center">
                                          <i
                                            className="fa-solid fa-check text-white icon_btn"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              handleDobSave();
                                            }}
                                          ></i>
                                          <i
                                            className="fa-solid fa-xmark text-white icon_btn"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setTempDobParts(dobParts);
                                              setShowDropdown(false);
                                            }}
                                          ></i>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {validuser?.dob ? (
                                    <p className="p-0 text-danger">
                                      {validuser?.dob}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-6">
                                <div className="mb-3">
                                  <label>
                                    {t("Country")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <Dropdown>
                                    <Dropdown.Toggle
                                      id="dropdown-select-country"
                                      className={
                                        validuser?.country?.label
                                          ? "form-select form-control border-danger"
                                          : "form-select form-control"
                                      }
                                    >
                                      {t(userdata?.country?.label) ||
                                        t("Select country")}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <input
                                        type="search"
                                        className="form-control  searchSelectDropdown"
                                        placeholder={`${t("Search")}...`}
                                        value={searchTerm}
                                        onChange={(e) =>
                                          setSearchTerm(e.target.value)
                                        }
                                      />

                                      {filteredCountries?.length ? (
                                        filteredCountries.map((result, key) => (
                                          <Dropdown.Item
                                            key={key}
                                            onClick={() => handleSelect(result)}
                                          >
                                            {t(result.label)}
                                          </Dropdown.Item>
                                        ))
                                      ) : (
                                        <Dropdown.Item disabled>
                                          {t("No results found")}
                                        </Dropdown.Item>
                                      )}
                                    </Dropdown.Menu>
                                  </Dropdown>

                                  {validuser?.country ? (
                                    <p className="p-0 text-danger">
                                      {validuser?.country}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="mb-3">
                                  <label>
                                    {t("State")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="state"
                                    placeholder={t("Enter your State")}
                                    value={userdata?.state}
                                    className={
                                      validuser?.state
                                        ? "form-control border-danger"
                                        : "form-control"
                                    }
                                    onChange={(e) =>
                                      setupuser("state", e.target.value)
                                    }
                                  />
                                  {validuser?.state ? (
                                    <p className="p-0 text-danger">
                                      {validuser?.state}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="mb-3">
                                  <label>
                                    {t("City")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="city"
                                    placeholder={t("Enter your City")}
                                    value={userdata?.city}
                                    className={
                                      validuser?.city
                                        ? "form-control border-danger"
                                        : "form-control"
                                    }
                                    onChange={(e) =>
                                      setupuser("city", e.target.value)
                                    }
                                  />
                                  {validuser?.city ? (
                                    <p className="p-0 text-danger">
                                      {validuser?.city}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="mb-3">
                                  <label>
                                    {t("Address")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="address"
                                    placeholder={t("Enter your address")}
                                    value={userdata?.address}
                                    className={
                                      validuser?.address
                                        ? "form-control border-danger"
                                        : "form-control"
                                    }
                                    onChange={(e) =>
                                      setupuser("address", e.target.value)
                                    }
                                  />
                                  {validuser?.address ? (
                                    <p className="p-0 text-danger">
                                      {validuser?.address}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              <div
                                className="col-12"
                                style={{
                                  pointerEvents: disablebuttio?.Personal
                                    ? "none"
                                    : "auto",
                                  opacity: disablebuttio?.Personal ? 0.5 : 1,
                                }}
                              >
                                <div className="group-btn02">
                                  <button
                                    onClick={() =>
                                      disablebuttio?.Personal
                                        ? null
                                        : uservalidaction()
                                    }
                                    type="button"
                                    className="btn bg-white"
                                    disabled={disablebuttio?.Personal}
                                  >
                                    {t("Save Personal Data")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 mb-4">
                          <div className="cardBox h-100">
                            <h4 className="card_title">Social Trading</h4>

                            <div className="row">
                              <div className="col-4">
                                <label className="m-0">Hide my profile</label>
                              </div>
                              <div className="col-8">
                                {socialnameloader?.hide_profile ? (
                                  <svg
                                    className="ajax-loader-v2__icon smallLoader"
                                    width="64"
                                    height="64"
                                    xmlns="http://www.w3.org/2000/svg"
                                    shapeRendering="geometricPrecision"
                                    textRendering="geometricPrecision"
                                    viewBox="0 0 64 64"
                                  >
                                    <style>
                                      {`
                                        @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
                                        @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
                                        @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
                                        @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
                                        @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
                                        @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
                                        @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
                                        @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
                                        @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
                                        @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
                                      `}
                                    </style>

                                    <rect
                                      width="2"
                                      height="37"
                                      fill="#0099fa"
                                      opacity="0"
                                      transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                                      }}
                                    />
                                    <rect
                                      width="10"
                                      height="19.5"
                                      fill="#0099fa"
                                      rx="1"
                                      opacity="0"
                                      transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                                      }}
                                    />
                                    <rect
                                      width="2"
                                      height="42"
                                      fill="#0099fa"
                                      opacity="0"
                                      transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                                      }}
                                    />
                                    <rect
                                      width="10"
                                      height="21"
                                      fill="#0099fa"
                                      rx="1"
                                      opacity="0"
                                      transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                                      }}
                                    />
                                    <rect
                                      width="2"
                                      height="28"
                                      fill="#0099fa"
                                      opacity="0"
                                      transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                                      }}
                                    />
                                    <rect
                                      width="10"
                                      height="16"
                                      fill="#0099fa"
                                      rx="1"
                                      opacity="0"
                                      transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                                      }}
                                    />
                                    <rect
                                      width="2"
                                      height="40"
                                      fill="#0099fa"
                                      opacity="0"
                                      transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                                      }}
                                    />
                                    <rect
                                      width="10"
                                      height="23"
                                      fill="#0099fa"
                                      rx="1"
                                      opacity="0"
                                      transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                                      }}
                                    />
                                  </svg>
                                ) : (
                                  <div className="Hidemyprofile p-0">
                                    <div className="form-check form-switch mb-0">
                                      <div className="check-input-div">
                                        <input
                                          value={
                                            userdata?.hide_profile === 1
                                              ? true
                                              : false
                                          }
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={
                                            userdata?.hide_profile === 1
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            updateuser(
                                              {
                                                ...userdata,
                                                hide_profile: e.target.checked
                                                  ? 1
                                                  : 0,
                                              },
                                              {
                                                hide_profile: true,
                                                nickname: false,
                                              },
                                            );
                                            setSocialnameloader((state) => ({
                                              ...state,
                                              hide_profile: true,
                                            }));
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <hr className="my-3" />
                            <div className="row">
                              <div className="col-4">
                                <label className="m-0">Nickname</label>
                              </div>
                              <div className="col-8">
                                {socialnameloader?.nickname ? (
                                  <svg
                                    className="ajax-loader-v2__icon smallLoader"
                                    width="64"
                                    height="64"
                                    xmlns="http://www.w3.org/2000/svg"
                                    shapeRendering="geometricPrecision"
                                    textRendering="geometricPrecision"
                                    viewBox="0 0 64 64"
                                  >
                                    <style>
                                      {`
                                        @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
                                        @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
                                        @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
                                        @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
                                        @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
                                        @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
                                        @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
                                        @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
                                        @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
                                        @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
                                        @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
                                      `}
                                    </style>

                                    <rect
                                      width="2"
                                      height="37"
                                      fill="#0099fa"
                                      opacity="0"
                                      transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                                      }}
                                    />
                                    <rect
                                      width="10"
                                      height="19.5"
                                      fill="#0099fa"
                                      rx="1"
                                      opacity="0"
                                      transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                                      }}
                                    />
                                    <rect
                                      width="2"
                                      height="42"
                                      fill="#0099fa"
                                      opacity="0"
                                      transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                                      }}
                                    />
                                    <rect
                                      width="10"
                                      height="21"
                                      fill="#0099fa"
                                      rx="1"
                                      opacity="0"
                                      transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                                      }}
                                    />
                                    <rect
                                      width="2"
                                      height="28"
                                      fill="#0099fa"
                                      opacity="0"
                                      transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                                      }}
                                    />
                                    <rect
                                      width="10"
                                      height="16"
                                      fill="#0099fa"
                                      rx="1"
                                      opacity="0"
                                      transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                                      }}
                                    />
                                    <rect
                                      width="2"
                                      height="40"
                                      fill="#0099fa"
                                      opacity="0"
                                      transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                                      }}
                                    />
                                    <rect
                                      width="10"
                                      height="23"
                                      fill="#0099fa"
                                      rx="1"
                                      opacity="0"
                                      transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                                      style={{
                                        animation:
                                          "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                                      }}
                                    />
                                  </svg>
                                ) : (
                                  <div className="nickname-input-div">
                                    {editnickname === false ? (
                                      <div
                                        className="text-white nickname-edit"
                                        onClick={() => setEditnickname(true)}
                                      >
                                        {userdata?.nickname || "Empty"}
                                      </div>
                                    ) : (
                                      <>
                                        <input
                                          value={userdata?.nickname || ""}
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            if (
                                              /^(?:[\p{L}\p{M}]){0,12}$/u.test(
                                                value,
                                              )
                                            ) {
                                              setUserdata((state) => ({
                                                ...state,
                                                nickname: value,
                                              }));
                                            }
                                          }}
                                          className="form-control"
                                          type="text"
                                        />
                                        <div className="icon_col d-flex align-items-center">
                                          <i
                                            className="fa-solid fa-check text-white icon_btn"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setEditnickname(false);
                                              updateuser(userdata, {
                                                hide_profile: false,
                                                nickname: true,
                                              });
                                              setSocialnameloader((state) => ({
                                                ...state,
                                                nickname: true,
                                              }));
                                            }}
                                          ></i>
                                          <i
                                            className="fa-solid fa-xmark text-white icon_btn"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              setEditnickname(false)
                                            }
                                          ></i>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <Userverify/> */}
                       <div className="cardBox mb-4">
                        <h4 className="card_title">
                          {t("Documents Verification")}
                          {userdata?.identity_status === 1 ? (
                            <span className="badge bg-success d-inline-flex ms-2">
                              {t("Verified")}
                            </span>
                          ) : userdata?.identity_status === 2 ? (
                            <span className="badge status-underconsideration d-inline-flex ms-2">
                              {t("Under Review")}
                            </span>
                          ) : userdata?.identity_status === 3 ? (
                            <span className="badge status-failed d-inline-flex ms-2">
                              {t("Declined")}
                            </span>
                          ) : (
                            ""
                          )}
                        </h4>
                       

                        {showvarification === false ? (
                          <>
                            {cameraAvailable === null ? (
                              <p>{t("Checking for camera")}...</p>
                            ) : cameraAvailable ? (
                              userdata?.user_source && userdata?.user_target ? (
                                <>
                                 
                                  <p style={{ color: "yellow" }}>
                                    Verification is pending. Please wait for the
                                    confirmation email.
                                  </p>
                                </>
                              ) : (
                                <>
                                  <div className="mb-3">
                                    <label>
                                      {t(
                                        "Upload your national ID for verification",
                                      )}{" "}
                                    </label>
                                    {userdata?.identity_status === 3 ? (
                                      <p style={{ color: "red" }}>
                                        Your document verification has been
                                        declined.Please try again.
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    {userdata?.user_source &&
                                      typeof userdata?.user_source ===
                                        "string" && (
                                        <img
                                          style={{
                                            width: "50px",
                                            height: "60px",
                                            objectFit: "cover",
                                          }}
                                          src={
                                            userdata?.user_source
                                              ? process.env
                                                  .REACT_APP_IMAGE_URL +
                                                userdata?.user_source
                                              : user
                                          }
                                          alt={user}
                                        />
                                      )}
                                    <input
                                      type="file"
                                      name="file"
                                      onChange={(e) =>
                                        uploadimage(e, "user_source")
                                      }
                                      class="form-control"
                                      style={{ lineHeight: "1.9" }}
                                    />
                                  </div>
                                  {capturedImage === null &&
                                  userdata?.user_source ? (
                                    <>
                                      <button
                                        className="btn bg-white"
                                        onClick={startCamera}
                                      >
                                        {t("Please take your selfie to match")}
                                      </button>
                                      <div style={{ marginTop: "10px" }}>
                                        <video
                                          ref={videoRef}
                                          width="300"
                                          height="200"
                                          autoPlay
                                          muted
                                          playsInline
                                        />
                                      </div>
                                      {checkopencamara && (
                                        <button
                                          className="btn bg-white"
                                          onClick={capturePhoto}
                                          style={{ marginTop: "10px" }}
                                        >
                                          {t("Capture Photo & Verify")}
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    imageloader?.loading1 && (
                                      <div
                                        className="spinner-border text-primary"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          {t("Loading...")}
                                        </span>
                                      </div>
                                    )
                                  )}

                                  <canvas
                                    ref={canvasRef}
                                    style={{ display: "none" }}
                                  />

                                  {capturedImage && (
                                    <div style={{ marginTop: "20px" }}>
                                      <h4>{t("Captured Image")}:</h4>
                                      <img
                                        style={{
                                          width: "280px",
                                          height: "200px",
                                          objectFit: "cover",
                                        }}
                                        src={capturedImage}
                                        alt="Captured"
                                        width="300"
                                      />
                                    </div>
                                  )}

                                  {verificationResult ? (
                                    <div style={{ marginTop: "20px" }}>
                                      <h4>{t("Verification Result")}:</h4>
                                      {verificationResult.error ? (
                                        <p style={{ color: "yellow" }}>
                                          {verificationResult.error}
                                        </p>
                                      ) : (
                                        <>
                                          <p>
                                            {" "}
                                            {verificationResult.verified ? (
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                                fill="rgba(100,205,138,1)"
                                              >
                                                <path d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"></path>
                                              </svg>
                                            ) : (
                                              <button
                                                className="btn bg-white"
                                                onClick={startCamera}
                                              >
                                                Selfie did not match. Please try
                                                again.
                                              </button>
                                            )}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    imageloader?.loading2 && (
                                      <div
                                        className="spinner-border text-primary"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          {t("Loading...")}
                                        </span>
                                      </div>
                                    )
                                  )}
                                </>
                              )
                            ) : userdata?.user_source &&
                              userdata?.user_target ? (
                              <>
                              
                                <p style={{ color: "yellow" }}>
                                  Verification is pending. Please wait for the
                                  confirmation email.
                                </p>
                              </>
                            ) : (
                              <p style={{ color: "red" }}>
                                {/* Webcam not found on this device. */}
                                 <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                          style={{
                                            textAlign: "center",
                                            border: "1px solid #474451",
                                            borderRadius: "8px",
                                            backgroundColor: "#151419",
                                            padding: "12px",
                                          }}
                                        >
                                        <h5 className="mb-0">QR Code</h5>
                                        {qrUrl && (
                                          <div style={{ marginTop: "16px" }}>
                                
                                            <QRCodeCanvas
                                              value={qrUrl}
                                              size={180}
                                              level="L"
                                                includeMargin={true}
                                            />
                                
                                            {/* <p
                                              style={{
                                                marginTop: "20px",
                                                wordBreak: "break-all",
                                                maxWidth: "400px",
                                              }}
                                            >
                                              {qrUrl}
                                            </p> */}
                                
                                            <p><small>Scan this QR code from your phone.</small></p>
                                
                                          </div>
                                        )}
                                
                                      </div>
                                
                                    </div>
                              </p>

                            )}
                            {error && <p style={{ color: "red" }}>{error}</p>}
                          </>
                        ) : (
                          ""
                        )}
                      </div> 
                      {userdata?.additional_document === 1 ? (
                        <div className="cardBox mb-4">
                          <div className="row">
                            <div className="col-12">
                              <h3 className="card_title">
                                {t("User Documents")}
                              </h3>
                            </div>
                          </div>

                          <div className="row">
                            {docloader ? (
                              <div className="text-center">
                                {" "}
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            ) : userdocumentlist?.length ? (
                              userdocumentlist.map((result, key) => {
                                return (
                                  <div className="col-xl-3 col-md-4 col-sm-6 col-12 mb-4">
                                    <div className="card UserDocuments_card">
                                     
                                      <div className="card-body">
                                        <p className="card-text">
                                          {result?.document_type}
                                        </p>
                                        <div>
                                          {result?.status === "pending" ? (
                                            <span class="badge text-bg-warning text-white">
                                              Pending
                                            </span>
                                          ) : result?.status === "rejected" ? (
                                            <span class="badge text-bg-danger">
                                              Failed
                                            </span>
                                          ) : (
                                            <span class="badge text-bg-success">
                                              Verified
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="col-12 text-center">
                                <div className="alert alert-danger">
                                  <p className="mb-0 text-white">
                                    No documents found.
                                  </p>
                                  
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="row">
                            <div className="col-12">
                              <button
                                className="btn bg_btn"
                                type="button"
                                onClick={() => {
                                  openModal("add_documentModal");
                                  setIsModalOpen(true);
                                }}
                               
                              >
                                {t("Add Document")}
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div
                        ref={(el) =>
                          (modalRefs.current["add_documentModal"] = el)
                        }
                        className="modal fade"
                        id="add_documentModal"
                        tabIndex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="exampleModalLabel"
                              >
                                {t("Add Document")}
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                  setIsModalOpen(false);
                                  setPreview(null);
                                  if (imageinputRef.current) {
                                    imageinputRef.current.value = "";
                                  }
                                }}
                              ></button>
                            </div>
                            <div className="modal-body">
                              <form className="banners_search">
                                <div className="row">
                                  <div className="col-12 mb-3">
                                    <h6 className="small-title">
                                      {t("Document Type")}
                                    </h6>
                                    <Dropdown className="custom-dropdown">
                                      <Dropdown.Toggle
                                        className="form-select form-control custom-toggle"
                                        id="dropdown-common"
                                      >
                                        {documentType || "Select Document Type"}
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu className="custom-menu">
                                        {documentlist?.length ? (
                                          documentlist.map((result, key) => {
                                            return (
                                              <Dropdown.Item
                                                key={key}
                                                onClick={() =>
                                                  setDocumentType(result)
                                                }
                                              >
                                                {result}
                                              </Dropdown.Item>
                                            );
                                          })
                                        ) : (
                                          <p className="text-center pt-1">
                                            No Data Found
                                          </p>
                                        )}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>

                                  {/* Upload */}
                                  <div className="col-12 mb-3">
                                    <h6 className="small-title">
                                      {t("Choose Image")}
                                    </h6>
                                    <div className="Choose_Image_select position-relative">
                                      <input
                                        type="file"
                                        accept="image/*"
                                        className="form-control"
                                        ref={imageinputRef}
                                        onChange={handleFileChange}
                                      />
                                      {/* {cameraAvailable && (
                            <i
                              onClick={openDeviceCamera}
                              role="button"
                              className="fa-solid fa-camera selfie_icon"
                            ></i>
                          )} */}
                                      {/* {showCamera && (
                                        <div className="camera-overlay">
                                          <video
                                            ref={videoRef}
                                            autoPlay
                                            playsInline
                                          />
                                          <canvas
                                            ref={canvasRef}
                                            className="d-none"
                                          />

                                          <div className="camera-actions">
                                            <button
                                              className="btn bg_btn"
                                              onClick={capturePhoto01}
                                            >
                                              Capture
                                            </button>
                                            <button
                                              className="btn"
                                              onClick={closeCamera}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      )} */}
                                    </div>
                                  </div>

                                  {/* Paste Box */}
                                  <div className="col-12 mb-3">
                                    <div className="paste-box mb-2 text-white">
                                      📋 {t("Paste image here (Ctrl + V)")}
                                    </div>

                                    {preview && (
                                      <div className="paste_images">
                                        <img src={preview} alt="Preview" />
                                      </div>
                                    )}
                                  </div>

                                  {/* Error */}
                                  {error && (
                                    <div className="col-12 mb-3 text-danger small">
                                      {error}
                                    </div>
                                  )}

                                  {/* Buttons */}
                                  <div className="col-12 d-flex justify-content-end">
                                    <button
                                      type="button"
                                      className="btn me-3"
                                      data-bs-dismiss="modal"
                                      onClick={() => {
                                        setIsModalOpen(false);
                                        setPreview(null);
                                        if (imageinputRef.current) {
                                          imageinputRef.current.value = "";
                                        }
                                      }}
                                    >
                                      {t("Cancel")}
                                    </button>
                                    <button
                                      disabled={uploaddisable}
                                      type="button"
                                      className="btn bg_btn"
                                      onClick={() => {
                                        handleSubmit();
                                      }}
                                    >
                                      {t("Upload")}
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* <div className="col-lg-4 col-md-5 mb-4">
                         <div className="cardBox h-100">
                             <div className="row">
                               <div className="col-lg-6 col-md-6">
                                 <h4 className="card_title">Trading Profile</h4>
                               </div>
                               <div className="col-lg-6 col-md-6"></div>
                               <div className="col-lg-12">
                                 <div className="table-responsive">
                                  <table className="table table-dark table-striped">
                                     <thead>
                                        <tr>
                                           <th>Trader Id</th>
                                           <th>Other Status</th>
                                        </tr>
                                     </thead>
                                     <tbody>
                                        <tr>
                                           <td>USD283835</td>
                                           <td>-</td>
                                        </tr>
                                        <tr>
                                           <td>USD245635</td>
                                           <td>-</td>
                                        </tr>
                                     </tbody>
                                  </table>
                                 </div>
                               </div>
                             </div>
                          </div>
                       </div>  */}

                        <div className="col-lg-12 col-md-12 mb-4">
                          <div className="cardBox h-100">
                            <h4 className="card_title">{t("Security")}</h4>
                            <form action="#">
                              <div className="row">
                                <div className="col-lg-6 col-md-6">
                                  <div className="mb-3 form-group position-relative">
                                    <label>{t("Old Password")}</label>
                                    <input
                                      value={password?.current_password}
                                      type={
                                        showpassword?.current_password
                                          ? "text"
                                          : "password"
                                      }
                                      name="password"
                                      className={
                                        passvalidmessage?.current_password
                                          ? "form-control border-danger"
                                          : "form-control"
                                      }
                                      placeholder={t("Enter old password")}
                                      onChange={(e) =>
                                        setuppassword(
                                          "current_password",
                                          e.target.value,
                                        )
                                      }
                                      style={{ paddingRight: "40px" }}
                                    />
                                    <i
                                      onClick={() =>
                                        setShowpassword((state) => ({
                                          ...state,
                                          current_password:
                                            !showpassword?.current_password,
                                        }))
                                      }
                                      className={`toggle-password fa-regular fa-fw ${
                                        showpassword?.current_password
                                          ? "fa-eye"
                                          : "fa-eye-slash"
                                      }`}
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: passvalidmessage?.current_password
                                          ? "50%"
                                          : "70%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "rgb(189 189 185)",
                                      }}
                                    ></i>
                                    {passvalidmessage?.current_password ? (
                                      <p className="p-0 text-danger">
                                        {passvalidmessage?.current_password}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="mb-3  position-relative">
                                    <label>{t("New Password")}</label>
                                    <input
                                      value={password?.new_password}
                                      type={
                                        showpassword?.new_password
                                          ? "text"
                                          : "password"
                                      }
                                      name="new_password"
                                      className={
                                        passvalidmessage?.new_password
                                          ? "form-control border-danger"
                                          : "form-control"
                                      }
                                      placeholder={t("Enter new password")}
                                      onChange={(e) =>
                                        setuppassword(
                                          "new_password",
                                          e.target.value,
                                        )
                                      }
                                      style={{ paddingRight: "40px" }}
                                    />
                                    <i
                                      onClick={() =>
                                        setShowpassword((state) => ({
                                          ...state,
                                          new_password:
                                            !showpassword?.new_password,
                                        }))
                                      }
                                      className={`toggle-password fa-regular fa-fw ${
                                        showpassword?.new_password
                                          ? "fa-eye"
                                          : "fa-eye-slash"
                                      }`}
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: passvalidmessage?.new_password
                                          ? "50%"
                                          : "70%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "rgb(189 189 185)",
                                      }}
                                    ></i>
                                    {passvalidmessage?.new_password ? (
                                      <p className="p-0 text-danger">
                                        {passvalidmessage?.new_password}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="mb-3 position-relative">
                                    <label>{t("Confirm New Password")}</label>
                                    <input
                                      value={password?.password}
                                      type={
                                        showpassword?.password
                                          ? "text"
                                          : "password"
                                      }
                                      name="new_password"
                                      className={
                                        passvalidmessage?.password
                                          ? "form-control border-danger"
                                          : "form-control"
                                      }
                                      placeholder={t("Confirm New Password")}
                                      onChange={(e) =>
                                        setuppassword(
                                          "password",
                                          e.target.value,
                                        )
                                      }
                                      style={{ paddingRight: "40px" }}
                                    />
                                    <i
                                      onClick={() =>
                                        setShowpassword((state) => ({
                                          ...state,
                                          password: !showpassword?.password,
                                        }))
                                      }
                                      className={`toggle-password fa-regular fa-fw ${
                                        showpassword?.password
                                          ? "fa-eye"
                                          : "fa-eye-slash"
                                      }`}
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top:
                                          passvalidmessage?.password ||
                                          passvalidmessage?.matchpassword
                                            ? "50%"
                                            : "70%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "rgb(189 189 185)",
                                      }}
                                    ></i>
                                    {passvalidmessage?.password ||
                                    passvalidmessage?.matchpassword ? (
                                      <p className="p-0 text-danger">
                                        {passvalidmessage?.password
                                          ? passvalidmessage?.password
                                          : passvalidmessage?.matchpassword}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div
                                  className="col-12"
                                  style={{
                                    pointerEvents: disablebuttio?.Security
                                      ? "none"
                                      : "auto",
                                    opacity: disablebuttio?.Security ? 0.5 : 1,
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      disablebuttio?.Security
                                        ? null
                                        : passwordvalid()
                                    }
                                    type="button"
                                    className="btn bg_btn"
                                    disabled={disablebuttio?.Security}
                                  >
                                    {t("Update")}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 col-md-6 mb-4">
                          <div className="cardBox h-100">
                            <div className="row">
                              <div className="col-lg-6 col-md-6">
                                <h4 className="card_title">
                                  {t("Login history")}
                                </h4>
                              </div>
                              <div className="col-lg-6 col-md-6"></div>
                              <div className="col-lg-12">
                                <div className="table-responsive">
                                  <table className="table table-dark table-striped">
                                    <thead>
                                      <tr>
                                        <th>{t("Date")}</th>
                                        <th>{t("IP")}</th>
                                        <th>{t("Device/OS")}</th>
                                        <th>{t("Browser")}</th>
                                        <th>{t("Country")}</th>
                                        {/* <th>City</th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {loadinglogin ? (
                                        <tr>
                                          <td
                                            colSpan="5"
                                            className="loaderparentpositaion"
                                          >
                                            <Commonloader show={true} />
                                          </td>
                                        </tr>
                                      ) : loginhistory?.length ? (
                                        loginhistory.map((result, key) => {
                                          return (
                                            <tr key={key}>
                                              <td>
                                                {formatDate(
                                                  result?.last_activity,
                                                )}
                                              </td>
                                              <td>
                                                {result?.ip_address
                                                  ? result?.ip_address
                                                  : "-"}
                                              </td>
                                              <td>
                                                {result?.os ? result?.os : "-"}
                                              </td>
                                              <td>
                                                {result?.browser
                                                  ? result?.browser
                                                  : "-"}
                                              </td>
                                              <td>
                                                {result?.country
                                                  ? result?.country
                                                  : "-"}
                                              </td>
                                              {/* <td>Jaipur</td> */}
                                            </tr>
                                          );
                                        })
                                      ) : (
                                        <tr className="no_data_table">
                                          <td
                                            colSpan={5}
                                            className="text-center"
                                          >
                                            {t("No Data Found")}
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                                {/* <nav aria-label="Page navigation example">
                                  <ul className="pagination justify-content-end">
                                    <li className="page-item disabled">
                                      <Link
                                        className="page-link"
                                        to=""
                                        onClick={(e)=>e.preventDefault()}
                                        tabindex="-1"
                                        aria-disabled="true"
                                      >
                                        Previous
                                      </Link>
                                    </li>
                                    <li className="page-item active">
                                      <Link className="page-link" to="" onClick={(e)=>e.preventDefault()}>
                                        1
                                      </Link>
                                    </li>
                                    <li className="page-item">
                                      <Link className="page-link" to="" onClick={(e)=>e.preventDefault()}>
                                        2
                                      </Link>
                                    </li>
                                    <li className="page-item">
                                      <Link className="page-link" to="" onClick={(e)=>e.preventDefault()}>
                                        3
                                      </Link>
                                    </li>
                                    <li className="page-item">
                                      <Link className="page-link" to="" onClick={(e)=>e.preventDefault()}>
                                        Next
                                      </Link>
                                    </li>
                                  </ul>
                                </nav> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 mb-4">
                          <div className="cardBox h-100">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="cardtitleWbtn">
                                  <h4 className="card_title">
                                    {t("Active sessions")}
                                  </h4>
                                  <button
                                    type="button"
                                    className="btn bg_btn"
                                    onClick={() =>
                                      terminatsessions("all", loginsection)
                                    }
                                  >
                                    {t("Terminate all")}
                                  </button>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="table-responsive">
                                  <table className="table table-dark table-striped">
                                    <thead>
                                      <tr>
                                        <th>{t("Last activity")}</th>
                                        <th>{t("IP")}</th>
                                        <th>{t("Device/OS")}</th>
                                        <th>{t("Browser")}</th>
                                        <th>{t("Country")}</th>
                                        <th>{t("Action")}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {loadingactive ? (
                                        <tr>
                                          <td
                                            colSpan="6"
                                            className="loaderparentpositaion"
                                          >
                                            <Commonloader show={true} />
                                          </td>
                                        </tr>
                                      ) : loginsection?.length ? (
                                        loginsection.map((result, key) => {
                                          return (
                                            <tr key={key}>
                                              <td>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 24 24"
                                                  width="12"
                                                  height="12"
                                                  fill="rgba(37,158,34,1)"
                                                >
                                                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"></path>
                                                </svg>{" "}
                                                {formatDate(
                                                  result?.last_activity,
                                                )}
                                              </td>
                                              <td>
                                                {" "}
                                                {result?.ip_address
                                                  ? result?.ip_address
                                                  : "-"}
                                              </td>
                                              <td>
                                                {result?.os ? result?.os : "-"}
                                              </td>
                                              <td>
                                                {result?.browser
                                                  ? result?.browser
                                                  : "-"}
                                              </td>
                                              <td>
                                                {result?.country
                                                  ? result?.country
                                                  : "-"}
                                              </td>
                                              <td>
                                                <button
                                                  type="button"
                                                  class="btn badge bg-danger"
                                                  onClick={() =>
                                                    terminatsessions(
                                                      "single",
                                                      result?.token_id,
                                                    )
                                                  }
                                                >
                                                  {t("Terminate")}
                                                </button>
                                              </td>
                                            </tr>
                                          );
                                        })
                                      ) : (
                                        <tr className="no_data_table">
                                          <td
                                            colSpan={6}
                                            className="text-center"
                                          >
                                            {t("No Data Found")}
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                                <Pagination
                                  totalItems={totalPagesactive || 20}
                                  itemsPerPage={itemsPerPageactive || 20}
                                  currentPage={currentPageactive || 1}
                                  goToPage={goToPageactive}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-12 col-md-12 mb-4">
                          <div className="cardBox h-100">
                            <h4 className="card_title">
                              {t("Select interface language")}
                            </h4>
                            <div className="boxbg">
                              <div className="row">
                                <div className="col-lg-4">
                                  <label>{t("Language")}</label>
                                </div>
                                <div className="col-lg-8">
                                  <div className="profile-languages">
                                    <ul>
                                      {langarr?.length
                                        ? langarr.map((result, key) => {
                                            return (
                                              <li>
                                                <button
                                                  onClick={() =>
                                                    setlang(result)
                                                  }
                                                  className={`lang-btn ${langcode?.Name === result?.Name && "active"}`}
                                                  key={key + 1}
                                                >
                                                  {result?.Name}
                                                  <div class="checkmark-wrapper">
                                                    <svg
                                                      className="svg-icon languages-check-icon checkmark"
                                                      viewBox="0 0 52 52"
                                                    >
                                                      <circle
                                                        className="checkmark-circle"
                                                        cx="24"
                                                        cy="24"
                                                        r="22"
                                                        fill="none"
                                                      />
                                                      <path
                                                        className="checkmark-check"
                                                        fill="none"
                                                        d="M14 27l7 7 16-16"
                                                      />
                                                    </svg>
                                                  </div>
                                                </button>
                                              </li>
                                            );
                                          })
                                        : ""}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              {/* <label>{t("Language")}</label>
                              <LanguageSelector /> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 mb-4">
                          <div
                            className="delete-account-btn"
                            style={{ maxWidth: "680px", margin: "0 auto" }}
                          >
                            <button
                              type="button"
                              style={{ border: "none" }}
                              class="btn bg-danger"
                              onClick={() => openModal("deletepopupmodal")}
                            >
                              {t("Delete account")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`tab-pane fade ${
                      state?.from === "analytics" && "show active"
                    }`}
                    id="analytics"
                    role="tabpanel"
                    aria-labelledby="analytics-tab"
                  >
                    <div className="analyticsrow">
                      <div className="row">
                        {/* <!-- Sidebar Profile Section --> */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
                          <div className="cardBox profile-card text-center p-3 mb-4">
                            <img
                              style={{
                                height: "120px",
                                objectFit: "cover",
                              }}
                              src={
                                userdata?.image
                                  ? process.env.REACT_APP_IMAGE_URL +
                                    userdata?.image
                                  : user
                              }
                              className="rounded-circle mb-3"
                              alt=""
                            />
                            <h4>{formatName(userdata?.name)}</h4>
                            <p className="text-muted real-account">
                              {t("Real Account Statistics")}
                            </p>
                            <div className="trq">
                              <p>
                                <span>UID:</span> {userdata?.id}
                              </p>
                              <p>
                                Balance:{" "}
                                <strong>
                                  ${formatPrice(userdata?.balance, 2)}
                                </strong>
                              </p>
                            </div>
                          </div>
                          <div className="cardBox p-3 rteq mb-4">
                            <h5 className="card_title">Trade Summary</h5>
                            <ServerDatePicker
                              fetchServerTime={fetchServerTimefordate}
                              onChange={handleDateChange}
                            />

                            <div className="tradeSummaryfilminh">
                              <div className="tab-content">
                                {loadingdata?.Trade_Summary ? (
                                  <CommonSpinner />
                                ) : (
                                  <div
                                    className={`trade-data tradeSummary tradeSummary-alert`}
                                  >
                                    <div
                                      className={`alert ${
                                        tradesummary?.trades_count !== 0
                                          ? "alert-success"
                                          : "alert-secondary"
                                      }`}
                                    >
                                      Trades:{" "}
                                      <span>
                                        {tradesummary?.trades_count ?? 0}
                                      </span>
                                    </div>

                                    <div
                                      className={`alert ${
                                        tradesummary?.profitable_trades === 0
                                          ? "alert-secondary"
                                          : tradesummary?.profitable_trades < 0
                                            ? "alert-danger"
                                            : tradesummary?.profitable_trades <
                                                30
                                              ? "alert-danger"
                                              : tradesummary?.profitable_trades <
                                                  60
                                                ? "alert-warning"
                                                : "alert-success"
                                      }`}
                                    >
                                      {t("Profitable Trades")}:{" "}
                                      <span>
                                        {tradesummary?.profitable_trades ?? 0}%
                                      </span>
                                    </div>

                                    <div
                                      className={`alert ${
                                        tradesummary?.trading_turnover !== 0
                                          ? "alert-success"
                                          : "alert-secondary"
                                      }`}
                                    >
                                      {t("Trading turnover:")}{" "}
                                      <span>
                                        $
                                        {formatPrice(
                                          tradesummary?.trading_turnover,
                                          2,
                                        ) ?? 0}
                                      </span>
                                    </div>

                                    <div
                                      className={`alert ${
                                        tradesummary?.net_turnover !== 0
                                          ? "alert-success"
                                          : "alert-secondary"
                                      }`}
                                    >
                                      {t("Net turnover:")}{" "}
                                      <span>
                                        $
                                        {formatPrice(
                                          tradesummary?.net_turnover,
                                          2,
                                        ) ?? 0}
                                      </span>
                                    </div>

                                    <div
                                      className={`alert ${
                                        tradesummary?.trades_profit === 0
                                          ? "alert-secondary"
                                          : tradesummary?.trades_profit > 0
                                            ? "alert-success"
                                            : "alert-danger"
                                      }`}
                                    >
                                      {t("Trading profit:")}{" "}
                                      <span>
                                        $
                                        {formatPrice(
                                          tradesummary?.trades_profit,
                                          2,
                                        ) ?? 0}
                                      </span>
                                    </div>

                                    <div
                                      className={`alert ${
                                        tradesummary?.max_trade_amount !== 0
                                          ? "alert-success"
                                          : "alert-secondary"
                                      }`}
                                    >
                                      {t("Max Trade")}:{" "}
                                      <span>
                                        $
                                        {formatPrice(
                                          tradesummary?.max_trade_amount,
                                          2,
                                        ) ?? 0}
                                      </span>
                                    </div>

                                    <div
                                      className={`alert ${
                                        tradesummary?.min_trade_amount !== 0
                                          ? "alert-success"
                                          : "alert-secondary"
                                      }`}
                                    >
                                      {t("Min Trade")}:{" "}
                                      <span>
                                        $
                                        {formatPrice(
                                          tradesummary?.min_trade_amount,
                                          2,
                                        ) ?? 0}
                                      </span>
                                    </div>

                                    <div
                                      className={`alert ${
                                        tradesummary?.max_profit === 0
                                          ? "alert-secondary"
                                          : tradesummary?.max_profit > 0
                                            ? "alert-success"
                                            : "alert-danger"
                                      }`}
                                    >
                                      {t("Max Profit")}:{" "}
                                      <span>
                                        $
                                        {formatPrice(
                                          tradesummary?.max_profit,
                                          2,
                                        ) ?? 0}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* <div className="cardBox p-4 cardTradesDistributionAssets">
                            <h4 className="card_title text-center">
                              {t("Trades Distribution by Assets")}
                            </h4>

                              {loadingdata?.Trades_Distribution_by_Assets ? (
                          <CommonSpinner />
                        ) : assetsDistributionData?.length ? (
                          // assetsDistributionData ? (
                            <HighchartsReact highcharts={Highcharts} options={optionsfortradedistributipon} />
                            // <Pie
                            //   data={assetsDistributionData}
                            //   options={options}
                            //   // plugins={[externalLabelsPlugin]}
                            // />
                          // ) : (
                          //   ""
                          // )
                        ) : (
                          <div className="text-center text-white NotradingHistory">
                            <span>
                              Trades Distribution by Assets
                              <br />
                              <small>No trading history</small>
                            </span>
                          </div>
                        )}
                          </div> */}
                        </div>

                        {/* <!-- Charts Section --> */}
                        <div className="col-xl-8 col-lg-8 col-md-6 col-sm-12">
                          <div className="cardBox p-4 cardProfitability mb-4">
                            <h4 className="card_title text-center">
                              {t("Profitability")}
                            </h4>
                            {/* <canvas id="profitabilityChart"></canvas> */}
                            {loadingdata?.Profitability ? (
                              <CommonSpinner />
                            ) : profitabilityData?.length ? (
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={optionsforprofit}
                              />
                            ) : (
                              <div className="text-center text-white NotradingHistory">
                                <span>
                                  Profitability
                                  <br />
                                  <small>No trading history</small>
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="cardBox p-4 cardTradesDistributionAssets mb-4">
                            <h4 className="card_title text-center">
                              {t("Trades Distribution by Assets")}
                            </h4>

                            {loadingdata?.Trades_Distribution_by_Assets ? (
                              <CommonSpinner />
                            ) : assetsDistributionData?.length ? (
                              // assetsDistributionData ? (
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={optionsfortradedistributipon}
                              />
                            ) : (
                              // <Pie
                              //   data={assetsDistributionData}
                              //   options={options}
                              //   // plugins={[externalLabelsPlugin]}
                              // />
                              // ) : (
                              //   ""
                              // )
                              <div className="text-center text-white NotradingHistory">
                                <span>
                                  Trades Distribution by Assets
                                  <br />
                                  <small>No trading history</small>
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="cardBox p-4 cardTradeAmountsAssets mb-4">
                            <h4 className="card_title text-center">
                              Trades number
                            </h4>
                            {loadingdata?.Trade_Amounts_by_Assets ? (
                              <CommonSpinner />
                            ) : tradeAmountsData?.categories?.length ? (
                              tradeAmountsData ? (
                                // <Bar
                                //   data={tradeAmountsData}
                                //   options={{
                                //     scales: { y: { beginAtZero: true } },
                                //   }}
                                // />
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={optionsforprofitloss}
                                />
                              ) : (
                                ""
                              )
                            ) : (
                              <div className="text-center text-white NotradingHistory">
                                <span>
                                  Trade Amounts by Assets
                                  <br />
                                  <small>No trading history</small>
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`tab-pane fade ${
                      state?.from === "trading_history" ? "show active" : ""
                    }`}
                    id="tradingHistory"
                    role="tabpanel"
                    aria-labelledby="tradingHistory-tab"
                  >
                    {/* <Commonloader show={loaderpage} /> */}
                    <form action="#" className="trade_historyfilter">
                      <CommonHistorydate
                        fetchServerTime={fetchServerTimefordate}
                        onChange={handlehistryDateChange}
                      />

                      <div className="form-group HistorySelect">
                        <label>{t("Trading History")}</label>
                        <CommonDropdown
                          label={
                            filterdates?.account_type?.label ||
                            "Real Trading History"
                          }
                          options={accounttypeoptcion}
                          onSelect={(val) =>
                            setFilterdates((state) => ({
                              ...state,
                              account_type: val,
                            }))
                          }
                        />
                      </div>
                      <div className="form-group HistorySelect">
                        <label>{t("Asset")}</label>
                        <CommonDropdown
                          label={filterdates?.asset?.name || "Nothing Selected"}
                          options={Assetlistpr}
                          onSelect={(val) =>
                            setFilterdates((state) => ({
                              ...state,
                              asset: val,
                            }))
                          }
                          labelKey="name"
                        />
                      </div>
                      <button
                        type="button"
                        className="btn bg_btn"
                        onClick={() =>
                          gettradehistory("filter", filterdates, true, true)
                        }
                      >
                        {t("Apply Filters")}{" "}
                        <i className="fa-solid fa-circle-check"></i>
                      </button>
                      {/* <button
                        type="button"
                        className="btn bg_btn"
                        onClick={() => {
                          resetfilter();
                        }}
                      >
                        {t("Reset Filters")}{" "}
                        <i className="fa-solid fa-circle-check"></i>
                      </button> */}
                      {exportexceldata?.length ? (
                        <button
                          type="button"
                          className="btn bg_btn"
                          onClick={() =>
                            exportToExcel(exportexceldata, "tradehistory.xlsx")
                          }
                        >
                          {t("Export to XLS")}{" "}
                          <i className="fa-solid fa-circle-check"></i>
                        </button>
                      ) : (
                        ""
                      )}
                    </form>

                    <div className="cardBox mb-4 table-mobile-view">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                          <h4 className="card_title">
                            {checkdemo === "demo"
                              ? t("History of Demo Trades")
                              : t("Real Trading History")}
                          </h4>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                          <div className="fillterOption">
                            <form className="searchbar">
                              <button type="button" className="">
                                <img src={searchnormal} alt="" />
                              </button>
                              <input
                                value={searchhistory}
                                placeholder="Enter asset"
                                type="search"
                                className="form-control"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) =>
                                  setSearchHistory(e.target.value)
                                }
                              />
                            </form>
                            {/* <!-- <button type="button" className="fillterBtn"><img src="images/setting-5.svg"></button> --> */}
                          </div>
                        </div>
                        <div className="col-lg-12 mt-md-4 mt-3">
                          <div className="table-responsive">
                            <table className="table table-dark table-striped tradingHistory-table">
                              <thead>
                                <tr>
                                  <th className="Trading_History_info">
                                    {t("Order")}
                                  </th>
                                  <th>{t("Asset")}</th>
                                  <th>{t("Expiration")}</th>
                                  <th className="desktop-d-none">
                                    {t("Opening Price")}
                                  </th>
                                  <th>{t("Opening quote")}</th>
                                  <th className="desktop-d-none">
                                    {t("Closing Price")}
                                  </th>
                                  <th>{t("Closing quote")}</th>
                                  <th>{t("IP")}</th>
                                  <th>{t("Amount")}</th>
                                  <th className="text-end">{t("Profit")}</th>
                                  <th></th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td
                                      colSpan="12"
                                      className="loaderparentpositaion"
                                    >
                                      <Commonloader show={true} />
                                    </td>
                                  </tr>
                                ) : tradehistorylist?.length ? (
                                  tradehistorylist.map((result, key) => {
                                    return (
                                      <tr>
                                        <td className="Trading_History_info">
                                          {/* <span className="tableSpan">
                                            {result?.payout
                                              ? result?.payout
                                              : 92}
                                            %
                                          </span> */}
                                          <div className="Trading_History_info01">
                                            {result?.type === "buy" ? (
                                              <img
                                                style={{
                                                  height: "20px",
                                                  width: "20px",
                                                }}
                                                src={up}
                                                alt=""
                                              />
                                            ) : (
                                              <img
                                                style={{
                                                  height: "20px",
                                                  width: "20px",
                                                }}
                                                src={Down}
                                                alt=""
                                              />
                                            )}
                                            {result?.reference_id
                                              ? result?.reference_id
                                              : ""}
                                          </div>
                                        </td>
                                        <td>
                                          {/* <img
                                            src={eurgbpflag}
                                            style={{
                                              width: "24px",
                                              height: "24px",
                                              marginRight: "5px",
                                            }}
                                            alt=""
                                          />{" "} */}
                                          {result?.asset_name
                                            ? result?.asset_name
                                            : result?.asset}
                                        </td>
                                        <td>
                                          {durationToSeconds(result?.duration)}
                                        </td>

                                        <td className="desktop-d-none">
                                          {result?.entry_price
                                            ? result?.entry_price
                                            : ""}
                                        </td>
                                        <td>
                                          <span className="tableSpan mobiled-none">
                                            {" "}
                                            {result?.entry_price
                                              ? result?.entry_price
                                              : ""}
                                          </span>
                                          {
                                            convertLocalToUTCFormatted(
                                              result?.trade_timestamp,
                                              updatetimezone,
                                            )?.datetime
                                          }
                                          {/* 2024-09-26 06:53:43 */}
                                        </td>

                                        <td className="desktop-d-none">
                                          {" "}
                                          {result?.exit_price
                                            ? result?.exit_price
                                            : ""}
                                        </td>
                                        <td>
                                          <span className="tableSpan  mobiled-none">
                                            {result?.exit_price
                                              ? result?.exit_price
                                              : ""}
                                          </span>
                                          {
                                            convertLocalToUTCFormatted(
                                              result?.close_time,
                                              updatetimezone,
                                            )?.datetime
                                          }
                                        </td>
                                        <td>{result?.ip ? result?.ip : "-"}</td>
                                        <td>
                                          $
                                          {result?.amount
                                            ? formatPrice(result?.amount, 2)
                                            : ""}
                                        </td>
                                        {result?.profit_loss < 0 ? (
                                          <>
                                            <td className="text-end">
                                              <span>$0</span>
                                              <span className="ps-1 tableSpan d-inline-block">
                                                (
                                                {result?.payout
                                                  ? result?.payout
                                                  : ""}
                                                %)
                                              </span>
                                            </td>
                                          </>
                                        ) : result?.profit_loss > 0 ? (
                                          <>
                                            <td className="text-end">
                                              <span
                                                className="priceUp"
                                                style={{ color: "#6fc274" }}
                                              >
                                                <i className="fa-solid fa-circle-up"></i>{" "}
                                                ${" "}
                                                {result?.profit_loss
                                                  ? formatPrice(
                                                      result?.profit_loss +
                                                        result?.amount,
                                                      2,
                                                    )
                                                  : ""}
                                              </span>{" "}
                                              <span className="ps-1 tableSpan d-inline-block">
                                                (
                                                {result?.payout
                                                  ? result?.payout
                                                  : ""}
                                                %)
                                              </span>
                                            </td>
                                          </>
                                        ) : (
                                          <td className="text-end">
                                            <span className="">
                                              ${formatPrice(result?.amount, 2)}
                                            </span>
                                          </td>
                                        )}
                                        <td
                                          className={`tradingHistoryCopied ${result?.copy_id ? "" : "d-none"}`}
                                        >
                                          <div>
                                            {result?.copy_id ? (
                                              <>
                                                <button class="badge text-bg-success">
                                                  Copied
                                                </button>
                                                <span
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#socialTradingview_popup"
                                                  onClick={() =>
                                                    getuseralldata(
                                                      result?.copy_user_id,
                                                      {
                                                        label: "Today",
                                                        value: "today",
                                                      },
                                                    )
                                                  }
                                                >
                                                  #{result?.copy_user_id}(
                                                  {formatName(
                                                    result?.copy_user_name,
                                                  )}
                                                  ){" "}
                                                </span>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </td>
                                        <td className="pointercursor">
                                          {parseFloat(
                                            result?.profit_loss,
                                          ).toFixed(2) < 0 &&
                                          result?.status !== "cancelled" &&
                                          result?.account_type === "real" &&
                                          checkcancal ? (
                                            <span
                                              className="badge rounded-pill bg-danger"
                                              onClick={() =>
                                                cancletrade(result?.id)
                                              }
                                            >
                                              Cancel
                                            </span>
                                          ) : result?.status === "cancelled" &&
                                            result?.account_type === "real" ? (
                                            <span className="badge rounded-pill bg-danger">
                                              Cancelled
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <>
                                    <tr className="no_data_table">
                                      <td colSpan={12} className="text-center">
                                        {!loading && "No Data Found"}
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <Pagination
                            totalItems={totalPages || 20}
                            itemsPerPage={itemsPerPage || 20}
                            currentPage={currentPage || 1}
                            goToPage={goToPage}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="cardBox mb-4" style={{ display: "none" }}>
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="card_title">
                            History of Social Trading
                          </h4>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="fillterOption">
                            <form className="searchbar">
                              <button type="button" className="">
                                <img src={searchnormal} alt="" />
                              </button>
                              <input type="search" className="form-control" />
                            </form>
                            {/* <!-- <button type="button" className="fillterBtn"><img src="images/setting-5.svg"></button> --> */}
                          </div>
                        </div>
                        <div className="col-lg-12 mt-4">
                          <div className="table-responsive">
                            <table className="table table-dark table-striped">
                              <thead>
                                <tr>
                                  <th>Order</th>
                                  <th>Asset</th>
                                  <th>Open time</th>
                                  <th>Expiry time</th>
                                  <th>Open price</th>
                                  <th>Closing price</th>
                                  <th>Amount</th>
                                  <th>Payout (%)</th>
                                  <th className="text-end">Profit</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>f8c1976e-b575-4323-b38b-520f9fe8fdc0 </td>
                                  <td>EURCHF</td>
                                  <td>2024-09-17 10:56</td>
                                  <td>2024-09-17 10:57</td>
                                  <td>0.93915</td>
                                  <td>0.93911</td>
                                  <td>$10</td>
                                  <td>58</td>
                                  <td className="text-end">$0</td>
                                </tr>
                                <tr>
                                  <td>f8c1976e-b575-4323-b38b-520f9fe8fdc0 </td>
                                  <td>EURCHF</td>
                                  <td>2024-09-17 10:56</td>
                                  <td>2024-09-17 10:57</td>
                                  <td>0.93915</td>
                                  <td>0.93911</td>
                                  <td>$10</td>
                                  <td>58</td>
                                  <td className="text-end">$0</td>
                                </tr>
                                <tr>
                                  <td>f8c1976e-b575-4323-b38b-520f9fe8fdc0 </td>
                                  <td>EURCHF</td>
                                  <td>2024-09-17 10:56</td>
                                  <td>2024-09-17 10:57</td>
                                  <td>0.93915</td>
                                  <td>0.93911</td>
                                  <td>$10</td>
                                  <td>58</td>
                                  <td className="text-end">$0</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="cardBox mb-4" style={{ display: "none" }}>
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="card_title">History of Demo Trades</h4>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="fillterOption">
                            <form className="searchbar">
                              <button type="button" className="">
                                <img src={searchnormal} alt="" />
                              </button>
                              <input type="search" className="form-control" />
                            </form>
                            {/* <!-- <button type="button" className="fillterBtn"><img src="images/setting-5.svg"></button> --> */}
                          </div>
                        </div>
                        <div className="col-lg-12 mt-4">
                          <div className="table-responsive">
                            <table className="table table-dark table-striped">
                              <thead>
                                <tr>
                                  <th>Order</th>
                                  <th>Asset</th>
                                  <th>Open time</th>
                                  <th>Expiry time</th>
                                  <th>Open price</th>
                                  <th>Closing price</th>
                                  <th>Amount</th>
                                  <th>Payout (%)</th>
                                  <th className="text-end">Profit</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>f8c1976e-b575-4323-b38b-520f9fe8fdc0 </td>
                                  <td>EURCHF</td>
                                  <td>2024-09-17 10:56</td>
                                  <td>2024-09-17 10:57</td>
                                  <td>0.93915</td>
                                  <td>0.93911</td>
                                  <td>$10</td>
                                  <td>58</td>
                                  <td className="text-end">$0</td>
                                </tr>
                                <tr>
                                  <td>f8c1976e-b575-4323-b38b-520f9fe8fdc0 </td>
                                  <td>EURCHF</td>
                                  <td>2024-09-17 10:56</td>
                                  <td>2024-09-17 10:57</td>
                                  <td>0.93915</td>
                                  <td>0.93911</td>
                                  <td>$10</td>
                                  <td>58</td>
                                  <td className="text-end">$0</td>
                                </tr>
                                <tr>
                                  <td>f8c1976e-b575-4323-b38b-520f9fe8fdc0 </td>
                                  <td>EURCHF</td>
                                  <td>2024-09-17 10:56</td>
                                  <td>2024-09-17 10:57</td>
                                  <td>0.93915</td>
                                  <td>0.93911</td>
                                  <td>$10</td>
                                  <td>58</td>
                                  <td className="text-end">$0</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Junkmailmodal modalRefs={modalRefs} />
        </section>

        <div
          className="modal fade"
          id="socialTradingview_popup"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="socialTradingLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div
                  className={`d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 ${
                    !modelloading && "d-none"
                  }`}
                  style={{
                    zIndex: 1,
                    backgroundColor: "rgb(0 0 0)",
                    borderRadius: "20px",
                    height: "100%",
                  }}
                >
                  <svg
                    className="ajax-loader-v2__icon"
                    width="64"
                    height="64"
                    xmlns="http://www.w3.org/2000/svg"
                    shapeRendering="geometricPrecision"
                    textRendering="geometricPrecision"
                    viewBox="0 0 64 64"
                    style={{ whiteSpace: "pre" }}
                  >
                    <style>
                      {`
        @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
        @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
        @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
        @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
        @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
        @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
        @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
        @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
        @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
        @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
      `}
                    </style>

                    <rect
                      width="2"
                      height="37"
                      fill="#fff"
                      opacity="0"
                      transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                      style={{
                        animation:
                          "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                      }}
                    />
                    <rect
                      width="10"
                      height="19.5"
                      fill="#fff"
                      rx="1"
                      opacity="0"
                      transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                      style={{
                        animation:
                          "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                      }}
                    />
                    <rect
                      width="2"
                      height="42"
                      fill="#fff"
                      opacity="0"
                      transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                      style={{
                        animation:
                          "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                      }}
                    />
                    <rect
                      width="10"
                      height="21"
                      fill="#fff"
                      rx="1"
                      opacity="0"
                      transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                      style={{
                        animation:
                          "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                      }}
                    />
                    <rect
                      width="2"
                      height="28"
                      fill="#fff"
                      opacity="0"
                      transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                      style={{
                        animation:
                          "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                      }}
                    />
                    <rect
                      width="10"
                      height="16"
                      fill="#fff"
                      rx="1"
                      opacity="0"
                      transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                      style={{
                        animation:
                          "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                      }}
                    />
                    <rect
                      width="2"
                      height="40"
                      fill="#fff"
                      opacity="0"
                      transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                      style={{
                        animation:
                          "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                      }}
                    />
                    <rect
                      width="10"
                      height="23"
                      fill="#fff"
                      rx="1"
                      opacity="0"
                      transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                      style={{
                        animation:
                          "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                      }}
                    />
                  </svg>
                </div>
                <h5 className="modal-title mb-3 big-title">
                  <span>Real Trading profile ID:</span>#{userfilter?.user_id}{" "}
                  <i
                    onClick={() => handleCopy(userfilter?.user_id)}
                    className="fa-regular fa-copy"
                    style={{ cursor: "pointer" }}
                  ></i>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                <div className="socialTradingview-body">
                  <div className="popup_profile_view">
                    <div className="profileTag">
                      <img
                        src={
                          userfilter?.user_profile
                            ? process.env.REACT_APP_IMAGE_URL +
                              userfilter?.user_profile
                            : user
                        }
                        className="profilepopPic"
                        alt=""
                      />
                    </div>
                    <div className="w-100">
                      <div className="profile_dt01">
                        <div className="view_dt">
                          <label>
                            {t("Name")}
                            <span>{userfilter?.user_name}</span>
                          </label>
                        </div>
                        <div className="view_dt">
                          <label>
                            {t("Status")}
                            {userfilter?.isOnline === "Online" ? (
                              <span>
                                {userfilter?.isOnline}{" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="12"
                                  height="12"
                                  fill="rgba(173,184,194,1)"
                                >
                                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"></path>
                                </svg>
                              </span>
                            ) : (
                              <span>{t("Offline")} </span>
                            )}
                          </label>
                        </div>
                        <div className="view_dt">
                          <label>
                            {t("Followers")}
                            <span>
                              {userdata?.followers ? userdata?.followers : 0}
                            </span>
                          </label>
                        </div>
                        <div className="view_dt">
                          <label>
                            {t("Profile Level")}
                            <span>{userfilter?.profile_level}</span>
                          </label>
                        </div>
                        <div className="view_dt">
                          <label>
                            {t("Account Level")}
                            <span>{userfilter?.account_level}</span>
                          </label>
                        </div>
                        <div className="view_dt">
                          <label>
                            {t("Watchers")}
                            <span>{userfilter?.watchers}</span>
                          </label>
                        </div>
                      </div>
                      {/* <div className="btnsGroupPop align-items-center">
                <button type="button" className="btn btnBorder"><span>Watch</span></button>
                <button type="button" className="btn btnBorder"><span>Copy</span></button>
              </div> */}
                    </div>
                  </div>

                  <div className="trading_profileViewHor">
                    {userfilter?.is_deleted ? (
                      <div class="row">
                        <div class="col-6">
                          <div class="popcard0">
                            <i class="fa-solid fa-xmark"></i>
                            <br />
                            The trader has disabled viewing profile statistics
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="popcard0">
                            <i class="fa-solid fa-xmark"></i>
                            <br />
                            The trader has disabled copying trades
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {userfilter?.blocked ||
                    userfilter?.watchblocked ||
                    !userfilter?.socialTradingSettings
                      ?.hideCopyingStatistics ? (
                      !userfilter?.is_deleted ? (
                        <div class="row">
                          {!userfilter?.socialTradingSettings
                            ?.hideWatchingTrading ? (
                            <div class="col-6">
                              <div class="popcard0">
                                <i class="fa-solid fa-xmark"></i>
                                <br />
                                The trader has disabled watching and copying of
                                trades
                              </div>
                            </div>
                          ) : (
                            <>
                              {userfilter?.blocked && (
                                <div class="col-6">
                                  <div class="popcard0">
                                    <i class="fa-solid fa-xmark"></i>
                                    <br />
                                    The trader has disabled copying trades
                                  </div>
                                </div>
                              )}
                              {userfilter?.watchblocked ||
                                (!userfilter?.socialTradingSettings
                                  ?.hideWatchingTrading && (
                                  <div class="col-6">
                                    <div class="popcard0">
                                      <i class="fa-solid fa-xmark"></i>
                                      <br />
                                      The trader has disabled watching trades
                                    </div>
                                  </div>
                                ))}
                            </>
                          )}

                          {!userfilter?.socialTradingSettings
                            ?.hideCopyingStatistics ? (
                            <div class="col-6">
                              <div class="popcard0">
                                <i class="fa-solid fa-vr-cardboard"></i>
                                <br />
                                The trader has disabled viewing profile
                                statistics
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {userfilter?.socialTradingSettings
                      ?.hideCopyingStatistics ? (
                      !userfilter?.is_deleted ? (
                        <>
                          <div
                            className="dropdown realTrading_dt"
                            ref={dropdownRef}
                          >
                            <CommonDropdown
                              label={selectedOption?.label || "Today"}
                              options={options}
                              onSelect={(val) => handledropSelect(val)}
                            />
                          </div>
                          <div className="tab-content" id="myTabContent">
                            <div
                              className="tab-pane fade show active"
                              id="today"
                              role="tabpanel"
                              aria-labelledby="today-tab"
                            >
                              <ul className="trade-data">
                                <li>
                                  {t("Trades")}{" "}
                                  <span>{userfilter?.trades_count}</span>
                                </li>
                                <li>
                                  {t("Profitable Trades")}{" "}
                                  <span>{userfilter?.profitable_trades}</span>
                                </li>
                                <li>
                                  {t("Profitable Trades (%)")}{" "}
                                  <span>
                                    {userfilter?.profitable_trades_percentage >
                                    0
                                      ? `${userfilter?.profitable_trades_percentage}%`
                                      : "0"}
                                  </span>
                                </li>
                                <li>
                                  {t("Trading Turnover")}{" "}
                                  <span>
                                    $
                                    {userfilter?.net_turnover
                                      ? userfilter?.net_turnover
                                      : "0.00"}
                                  </span>
                                </li>
                                <li>
                                  {t("Trading Profit")}{" "}
                                  <span>
                                    $
                                    {userfilter?.trades_profit
                                      ? userfilter?.trades_profit
                                      : "0.00"}
                                  </span>
                                </li>
                                <li>
                                  {t("Max Trade")}{" "}
                                  <span>
                                    $
                                    {userfilter?.max_trade_amount
                                      ? userfilter?.max_trade_amount
                                      : "0.00"}
                                  </span>
                                </li>
                                <li>
                                  {t("Min Trade")}{" "}
                                  <span>
                                    $
                                    {userfilter?.min_trade_amount
                                      ? userfilter?.min_trade_amount
                                      : "0.00"}
                                  </span>
                                </li>
                                <li>
                                  {t("Max Profit")}{" "}
                                  <span>
                                    $
                                    {userfilter?.max_profit
                                      ? userfilter?.max_profit
                                      : "0.00"}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={(el) => (modalRefs.current["deletepopupmodal"] = el)}
          className="modal fade"
          id="deletepopupmodal"
          tabindex="-1"
          aria-labelledby="joinUsModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-body">
                <h5 className="modal-title">{t("Delete account")}</h5>
                <button
                  onClick={() => setDeleteresion("")}
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                <p>
                  {t(
                    "We are sorry that you decided to leave us. Please select the reason why do you want to close your trading account",
                  )}
                  :
                </p>
                <div className="dropdown realTrading_dt w-100 mw-100">
                  <CommonDropdown
                    label={deleteresion || t("Select reason")}
                    options={deleteresiondata}
                    onSelect={(val) => setDeleteresion(val)}
                  />
                </div>

                <div className={`${!deleteresion && "d-none"}`}>
                  {deleteresion && reasonMessages[deleteresion]?.text && (
                    <div className="px-3 py-2 bg-dark my-2">
                      <p className="mb-0">
                        {reasonMessages[deleteresion]?.text
                          .split("{{support}}")
                          .map((part, index, arr) => (
                            <React.Fragment key={index}>
                              {part}
                              {index < arr.length - 1 && (
                                <Link
                                  onClick={handleSupportClick}
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                  style={{ textDecoration: "none" }}
                                >
                                  {t("Support Service")}
                                </Link>
                              )}
                            </React.Fragment>
                          ))}
                      </p>
                    </div>
                  )}
                  {deleteresion === "Other reason (Please specify)" ? (
                    <>
                      <textarea
                        className="from-control"
                        onChange={(e) => setDeleteresiontext(e.target.value)}
                      ></textarea>
                      {deletetext && (
                        <p className="text-danger">{deletetext}</p>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  <p>
                    {t(
                      "If you still wish to close your account, confirm below. You will be able to automatically restore your account within 30 days",
                    )}
                  </p>
                  <div className="delete-account-btn">
                    <button
                      type="button"
                      style={{ border: "none" }}
                      class="btn bg-danger"
                      onClick={() => setDeleteresion("")}
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      type="button"
                      style={{ border: "none" }}
                      class="btn bg-success"
                      onClick={() => deleteaccount(deleteresion)}
                    >
                      {t("Confirm")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Countryselect setCountry={setCountry} />
    </React.Fragment>
  );
};

export default Accountprofile;
